import 'viewerjs/dist/viewer.min.js';
import 'jquery-viewer/dist/jquery-viewer.min.js';
import 'select2/dist/js/select2.min.js';
import AOS from 'aos';
import 'flickity/dist/flickity.pkgd.js';
import Flickity from 'flickity';
import FlickityTransformer from 'flickity-transformer';
import Hammer from 'hammerjs';

// sticky header variable
var shrinkHeader = 100;

Flickity.prototype._createResizeClass = function () {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

export default {
  init() {
    // JavaScript to be fired on all pages

    // Flickity.defaults.dragThreshold = 3;
  },
  finalize() {

    AOS.init();
    // JavaScript to be fired on all pages, after page specific JS is fired

    let mapsSectionWidth = checkMapWidth();

    let fanPumpCalculatorJSON = [
      {
        'frameSize': 120,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 16,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 38.40,
        'powerAt1000Rpm': 5.47,
        'powerAtMaxSpeed': 13.12,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 24.1,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 57.84,
        'powerAt1000Rpm': 8.23,
        'powerAtMaxSpeed': 19.76,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 32.2,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 77.28,
        'powerAt1000Rpm': 11.00,
        'powerAtMaxSpeed': 26.40,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 40.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 96.72,
        'powerAt1000Rpm': 13.77,
        'powerAtMaxSpeed': 33.05,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 48.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 115.92,
        'powerAt1000Rpm': 16.50,
        'powerAtMaxSpeed': 39.61,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 56.4,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 135.36,
        'powerAt1000Rpm': 15.98,
        'powerAtMaxSpeed': 38.35,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 64.5,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 154.80,
        'powerAt1000Rpm': 18.28,
        'powerAtMaxSpeed': 43.86,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 120,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 20.8,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 49.92,
        'powerAt1000Rpm': 5.89,
        'powerAtMaxSpeed': 14.14,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 31.2,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 74.88,
        'powerAt1000Rpm': 8.84,
        'powerAtMaxSpeed': 21.22,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 41.7,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 100.08,
        'powerAt1000Rpm': 11.82,
        'powerAtMaxSpeed': 28.36,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 52.1,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 125.04,
        'powerAt1000Rpm': 14.76,
        'powerAtMaxSpeed': 35.43,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 62.6,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 150.24,
        'powerAt1000Rpm': 17.74,
        'powerAtMaxSpeed': 42.57,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 73,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 175.20,
        'powerAt1000Rpm': 18.62,
        'powerAtMaxSpeed': 44.68,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 83.5,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 200.40,
        'powerAt1000Rpm': 21.29,
        'powerAtMaxSpeed': 51.10,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 94,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 225.60,
        'powerAt1000Rpm': 21.62,
        'powerAtMaxSpeed': 51.89,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 104.4,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 250.56,
        'powerAt1000Rpm': 24.01,
        'powerAtMaxSpeed': 57.63,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 125,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 16,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 38.40,
        'powerAt1000Rpm': 4.53,
        'powerAtMaxSpeed': 10.88,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 24.1,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 57.84,
        'powerAt1000Rpm': 6.83,
        'powerAtMaxSpeed': 16.39,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 32.2,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 77.28,
        'powerAt1000Rpm': 9.12,
        'powerAtMaxSpeed': 21.90,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 40.3,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 96.72,
        'powerAt1000Rpm': 11.42,
        'powerAtMaxSpeed': 27.40,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 48.3,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 115.92,
        'powerAt1000Rpm': 13.69,
        'powerAtMaxSpeed': 32.84,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 56.4,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 135.36,
        'powerAt1000Rpm': 14.38,
        'powerAtMaxSpeed': 34.52,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 64.5,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 154.80,
        'powerAt1000Rpm': 16.45,
        'powerAtMaxSpeed': 39.47,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 72.6,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 174.24,
        'powerAt1000Rpm': 16.70,
        'powerAtMaxSpeed': 40.08,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 80,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 192.00,
        'powerAt1000Rpm': 18.40,
        'powerAtMaxSpeed': 44.16,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 130,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 16,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 38.40,
        'powerAt1000Rpm': 5.47,
        'powerAtMaxSpeed': 13.12,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 24.1,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 57.84,
        'powerAt1000Rpm': 8.23,
        'powerAtMaxSpeed': 19.76,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 32.2,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 77.28,
        'powerAt1000Rpm': 11.00,
        'powerAtMaxSpeed': 26.40,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 40.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 96.72,
        'powerAt1000Rpm': 13.77,
        'powerAtMaxSpeed': 33.05,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 48.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 115.92,
        'powerAt1000Rpm': 16.50,
        'powerAtMaxSpeed': 39.61,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 56.4,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 135.36,
        'powerAt1000Rpm': 15.98,
        'powerAtMaxSpeed': 38.35,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 64.5,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 154.80,
        'powerAt1000Rpm': 18.28,
        'powerAtMaxSpeed': 43.86,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 72.6,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 174.24,
        'powerAt1000Rpm': 18.51,
        'powerAtMaxSpeed': 44.43,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 80,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 192.00,
        'powerAt1000Rpm': 20.40,
        'powerAtMaxSpeed': 48.96,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 131,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 20.8,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 49.92,
        'powerAt1000Rpm': 5.89,
        'powerAtMaxSpeed': 14.14,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 31.2,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 74.88,
        'powerAt1000Rpm': 8.84,
        'powerAtMaxSpeed': 21.22,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 41.7,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 100.08,
        'powerAt1000Rpm': 11.82,
        'powerAtMaxSpeed': 28.36,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 52.1,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 125.04,
        'powerAt1000Rpm': 14.76,
        'powerAtMaxSpeed': 35.43,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 62.6,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 150.24,
        'powerAt1000Rpm': 17.74,
        'powerAtMaxSpeed': 42.57,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 73,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 175.20,
        'powerAt1000Rpm': 18.62,
        'powerAtMaxSpeed': 44.68,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 83.5,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 200.40,
        'powerAt1000Rpm': 21.29,
        'powerAtMaxSpeed': 51.10,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 94,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 225.60,
        'powerAt1000Rpm': 21.62,
        'powerAtMaxSpeed': 51.89,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 104.4,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 250.56,
        'powerAt1000Rpm': 24.01,
        'powerAtMaxSpeed': 57.63,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 150,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 20.8,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 49.92,
        'powerAt1000Rpm': 7.11,
        'powerAtMaxSpeed': 17.06,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 31.2,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 74.88,
        'powerAt1000Rpm': 10.66,
        'powerAtMaxSpeed': 25.58,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 41.7,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 100.08,
        'powerAt1000Rpm': 14.25,
        'powerAtMaxSpeed': 34.19,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 52.1,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 125.04,
        'powerAt1000Rpm': 17.80,
        'powerAtMaxSpeed': 42.72,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 62.6,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 150.24,
        'powerAt1000Rpm': 21.39,
        'powerAtMaxSpeed': 51.33,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 73,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 175.20,
        'powerAt1000Rpm': 20.68,
        'powerAtMaxSpeed': 49.64,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 83.5,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 200.40,
        'powerAt1000Rpm': 23.66,
        'powerAtMaxSpeed': 56.78,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 94,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 225.60,
        'powerAt1000Rpm': 23.97,
        'powerAtMaxSpeed': 57.53,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 104.4,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 250.56,
        'powerAt1000Rpm': 26.62,
        'powerAtMaxSpeed': 63.89,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 151,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 50.3,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 120.72,
        'powerAt1000Rpm': 14.25,
        'powerAtMaxSpeed': 34.20,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 67.1,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 161.04,
        'powerAt1000Rpm': 19.01,
        'powerAtMaxSpeed': 45.63,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 84,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 201.60,
        'powerAt1000Rpm': 23.80,
        'powerAtMaxSpeed': 57.12,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 100.6,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 241.44,
        'powerAt1000Rpm': 28.50,
        'powerAtMaxSpeed': 68.41,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 117.5,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 282.00,
        'powerAt1000Rpm': 33.29,
        'powerAtMaxSpeed': 79.90,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 134.3,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 322.32,
        'powerAt1000Rpm': 38.05,
        'powerAtMaxSpeed': 91.32,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 151,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 362.40,
        'powerAt1000Rpm': 38.51,
        'powerAtMaxSpeed': 92.41,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 168,
        'maxPressureBar': 153,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 403.20,
        'powerAt1000Rpm': 42.84,
        'powerAtMaxSpeed': 102.82,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 175,
        'gearHousingWidth': '4.00"(4")',
        'ccPerRev': 184.5,
        'maxPressureBar': 138,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 442.80,
        'powerAt1000Rpm': 42.44,
        'powerAtMaxSpeed': 101.84,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '1.25"(11/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '1.75"(13/4")',
        'ccPerRev': 0,
        'maxPressureBar': 0,
        'maxSpeed': 0,
        'maxFlowRateLpm': 0.00,
        'powerAt1000Rpm': 0.00,
        'powerAtMaxSpeed': 0.00,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '2.00"(2")',
        'ccPerRev': 50.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 120.72,
        'powerAt1000Rpm': 17.19,
        'powerAtMaxSpeed': 41.25,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '2.25"(21/4")',
        'ccPerRev': 67.1,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 161.04,
        'powerAt1000Rpm': 22.93,
        'powerAtMaxSpeed': 55.02,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '2.50"(21/2")',
        'ccPerRev': 84,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 201.60,
        'powerAt1000Rpm': 28.70,
        'powerAtMaxSpeed': 68.88,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '2.75"(23/4")',
        'ccPerRev': 100.6,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 241.44,
        'powerAt1000Rpm': 34.37,
        'powerAtMaxSpeed': 82.49,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '3.00"(3")',
        'ccPerRev': 117.5,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 282.00,
        'powerAt1000Rpm': 40.15,
        'powerAtMaxSpeed': 96.35,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '3.25"(31/4")',
        'ccPerRev': 134.3,
        'maxPressureBar': 205,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 322.32,
        'powerAt1000Rpm': 45.89,
        'powerAtMaxSpeed': 110.13,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '3.50"(31/2")',
        'ccPerRev': 151,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 362.40,
        'powerAt1000Rpm': 42.78,
        'powerAtMaxSpeed': 102.68,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
      {
        'frameSize': 176,
        'gearHousingWidth': '3.75"(3/4")',
        'ccPerRev': 168,
        'maxPressureBar': 170,
        'maxSpeed': 2400,
        'maxFlowRateLpm': 403.20,
        'powerAt1000Rpm': 47.60,
        'powerAtMaxSpeed': 114.24,
        'matchscoreA': 0,
        'matchscoreB': 0,
      },
    ]

    let fanPumpMotorDataJSON = [
      {
        'name': 'spu-2u-dc-48',
        'motorFrame': 'sPU',
        'motorLength': '2U',
        'acDc': 'DC Battery',
        'voltage': '48',
        'peakTorqueAt1000Rpm': 91,
        'peakTorqueAtMaxSpeed': 23,
        'contTorqueAt1000Rpm': 13,
        'contTorqueAtMaxSpeed': 8,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 2.41,
        'peakPowerAtMaxSpeed': 9.63,
        'contPowerAt1000Rpm': 1.36,
        'contPowerAtMaxSpeed': 3.35,
      },
      {
        'name': 'spu-4u-dc-48',
        'motorFrame': 'sPU',
        'motorLength': '4U',
        'acDc': 'DC Battery',
        'voltage': '48',
        'peakTorqueAt1000Rpm': 109,
        'peakTorqueAtMaxSpeed': 44,
        'contTorqueAt1000Rpm': 23,
        'contTorqueAtMaxSpeed': 12,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 4.61,
        'peakPowerAtMaxSpeed': 18.43,
        'contPowerAt1000Rpm': 2.41,
        'contPowerAtMaxSpeed': 5.03,
      },
      {
        'name': 'ipu-1u-dc-48',
        'motorFrame': 'iPU',
        'motorLength': '1U',
        'acDc': 'DC Battery',
        'voltage': '48',
        'peakTorqueAt1000Rpm': 107,
        'peakTorqueAtMaxSpeed': 26,
        'contTorqueAt1000Rpm': 33,
        'contTorqueAtMaxSpeed': 16,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 2.72,
        'peakPowerAtMaxSpeed': 10.89,
        'contPowerAt1000Rpm': 3.46,
        'contPowerAtMaxSpeed': 6.7,
      },
      {
        'name': 'ipu-2u-dc-48',
        'motorFrame': 'iPU',
        'motorLength': '2U',
        'acDc': 'DC Battery',
        'voltage': '48',
        'peakTorqueAt1000Rpm': 143,
        'peakTorqueAtMaxSpeed': 55,
        'contTorqueAt1000Rpm': 71,
        'contTorqueAtMaxSpeed': 36,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 5.76,
        'peakPowerAtMaxSpeed': 23.04,
        'contPowerAt1000Rpm': 7.44,
        'contPowerAtMaxSpeed': 15.08,
      },
      {
        'name': 'ipu-4u-dc-48',
        'motorFrame': 'iPU',
        'motorLength': '4U',
        'acDc': 'DC Battery',
        'voltage': '48',
        'peakTorqueAt1000Rpm': 161,
        'peakTorqueAtMaxSpeed': 60,
        'contTorqueAt1000Rpm': 143,
        'contTorqueAtMaxSpeed': 73,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 6.28,
        'peakPowerAtMaxSpeed': 25.13,
        'contPowerAt1000Rpm': 14.98,
        'contPowerAtMaxSpeed': 30.58,
      },
      {
        'name': 'ipu-2u-dc-400',
        'motorFrame': 'iPU',
        'motorLength': '2U',
        'acDc': 'DC Battery',
        'voltage': '400',
        'peakTorqueAt1000Rpm': 158,
        'peakTorqueAtMaxSpeed': 157,
        'contTorqueAt1000Rpm': 73,
        'contTorqueAtMaxSpeed': 70,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 16.44,
        'peakPowerAtMaxSpeed': 65.77,
        'contPowerAt1000Rpm': 7.64,
        'contPowerAtMaxSpeed': 29.32,
      },
      {
        'name': 'ipu-4u-dc-400',
        'motorFrame': 'iPU',
        'motorLength': '4U',
        'acDc': 'DC Battery',
        'voltage': '400',
        'peakTorqueAt1000Rpm': 325,
        'peakTorqueAtMaxSpeed': 108,
        'contTorqueAt1000Rpm': 148,
        'contTorqueAtMaxSpeed': 78,
        'maxSpeedRpm': 4000,
        'peakPowerAt1000Rpm': 11.31,
        'peakPowerAtMaxSpeed': 45.24,
        'contPowerAt1000Rpm': 15.5,
        'contPowerAtMaxSpeed': 32.67,
      },
      {
        'name': 'ipu-1u-ac-310',
        'motorFrame': 'iPU',
        'motorLength': '1U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 63,
        'peakTorqueAtMaxSpeed': 63,
        'contTorqueAt1000Rpm': 27.5,
        'contTorqueAtMaxSpeed': 27.5,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 6.6,
        'peakPowerAtMaxSpeed': 19.79,
        'contPowerAt1000Rpm': 2.88,
        'contPowerAtMaxSpeed': 8.64,
      },
      {
        'name': 'ipu-2u-ac-310',
        'motorFrame': 'iPU',
        'motorLength': '2U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 126,
        'peakTorqueAtMaxSpeed': 126,
        'contTorqueAt1000Rpm': 55,
        'contTorqueAtMaxSpeed': 55,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 13.2,
        'peakPowerAtMaxSpeed': 39.59,
        'contPowerAt1000Rpm': 5.76,
        'contPowerAtMaxSpeed': 17.28,
      },
      {
        'name': 'ipu-3u-ac-310',
        'motorFrame': 'iPU',
        'motorLength': '3U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 189,
        'peakTorqueAtMaxSpeed': 189,
        'contTorqueAt1000Rpm': 82.5,
        'contTorqueAtMaxSpeed': 82.5,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 19.79,
        'peakPowerAtMaxSpeed': 59.38,
        'contPowerAt1000Rpm': 8.64,
        'contPowerAtMaxSpeed': 25.92,
      },
      {
        'name': 'ipu-4u-ac-310',
        'motorFrame': 'iPU',
        'motorLength': '4U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 252,
        'peakTorqueAtMaxSpeed': 252,
        'contTorqueAt1000Rpm': 110,
        'contTorqueAtMaxSpeed': 110,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 26.39,
        'peakPowerAtMaxSpeed': 79.17,
        'contPowerAt1000Rpm': 11.52,
        'contPowerAtMaxSpeed': 34.56,
      },
      {
        'name': 'spu-1u-ac-310',
        'motorFrame': 'sPU',
        'motorLength': '1U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 19.8,
        'peakTorqueAtMaxSpeed': 19.8,
        'contTorqueAt1000Rpm': 5.9,
        'contTorqueAtMaxSpeed': 5.9,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 2.07,
        'peakPowerAtMaxSpeed': 6.22,
        'contPowerAt1000Rpm': 0.62,
        'contPowerAtMaxSpeed': 1.85,
      },
      {
        'name': 'spu-2u-ac-310',
        'motorFrame': 'sPU',
        'motorLength': '2U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 39.6,
        'peakTorqueAtMaxSpeed': 39.6,
        'contTorqueAt1000Rpm': 11.8,
        'contTorqueAtMaxSpeed': 11.8,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 4.15,
        'peakPowerAtMaxSpeed': 12.44,
        'contPowerAt1000Rpm': 1.24,
        'contPowerAtMaxSpeed': 3.71,
      },
      {
        'name': 'spu-3u-ac-310',
        'motorFrame': 'sPU',
        'motorLength': '3U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 59.4,
        'peakTorqueAtMaxSpeed': 59.4,
        'contTorqueAt1000Rpm': 17.7,
        'contTorqueAtMaxSpeed': 17.7,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 6.22,
        'peakPowerAtMaxSpeed': 18.66,
        'contPowerAt1000Rpm': 1.85,
        'contPowerAtMaxSpeed': 5.56,
      },
      {
        'name': 'spu-4u-ac-310',
        'motorFrame': 'sPU',
        'motorLength': '4U',
        'acDc': 'AC Mains',
        'voltage': '310',
        'peakTorqueAt1000Rpm': 79.2,
        'peakTorqueAtMaxSpeed': 79.2,
        'contTorqueAt1000Rpm': 23.6,
        'contTorqueAtMaxSpeed': 23.6,
        'maxSpeedRpm': 3000,
        'peakPowerAt1000Rpm': 8.29,
        'peakPowerAtMaxSpeed': 24.88,
        'contPowerAt1000Rpm': 2.47,
        'contPowerAtMaxSpeed': 7.41,
      },
    ]

    try {
      const acfData = JSON.parse(eval('jsonPumpAndFan'));

      fanPumpMotorDataJSON = fanPumpMotorDataJSON.map(motor => {
        const acf = acfData[motor.name] || {};
        return Object.assign({}, motor, {
          pageLink: acf.pageLink || '',
          pdfLink: acf.pdfLink || '',
        });
      });
    } catch (e) {
      // jsonPumpAndFan is not defined on this page, skip ACF data enrichment
    }

    if (mapsSectionWidth == true) {
      $('#map-address-wrp').addClass('flickity-now');
      mapSectionSlider()
    }

    else {
      mapSectionSliderDestroy()
    }

    let wpcf7Element = document.querySelector('#motor-calculator-section.automotive-calculator .calculator-contact-form-wrp .wpcf7');

    if (wpcf7Element) {
      wpcf7Element.addEventListener('wpcf7invalid', function (event) {
        event.preventDefault();
        $('#motor-calculator-section.automotive-calculator').addClass('invalid-form');
      }, false);

      wpcf7Element.addEventListener('wpcf7mailsent', function (event) {
        event.preventDefault();
        $('#motor-calculator-section.automotive-calculator').removeClass('invalid-form');
      }, false);
    }

    let wpcf7ElementNew = document.querySelector('#motor-calculator-section.heavy-vehicle-calculator .calculator-contact-form-wrp .wpcf7');

    if (wpcf7ElementNew) {
      wpcf7ElementNew.addEventListener('wpcf7invalid', function (event) {
        event.preventDefault();
        $('#motor-calculator-section.heavy-vehicle-calculator').addClass('invalid-form');
      }, false);

      wpcf7ElementNew.addEventListener('wpcf7mailsent', function (event) {
        event.preventDefault();
        $('#motor-calculator-section.heavy-vehicle-calculator').removeClass('invalid-form');
      }, false);
    }

    // Add Apllications for Motor Calculations
    let wpcf7AccordionForm = document.querySelector('.accordion-form-section .wpcf7');

    if (wpcf7AccordionForm) {
      wpcf7AccordionForm.addEventListener('wpcf7invalid', function (event) {
        event.preventDefault();

        $('.accordion-form-section .accordion-item-wrp').each(function () {
          $(this).find('.faq-title').addClass('collapsed');
          $(this).find('.faq-content').removeClass('show');
        });

        $('.accordion-form-section .accordion-item-wrp').first().find('.faq-title').removeClass('collapsed');
        $('.accordion-form-section .accordion-item-wrp').first().find('.faq-content').addClass('show');
      }, false);
    }
    // Add Apllications for Motor Calculations

    // Slope Calculations
    $('#motor-calculator-section.heavy-vehicle-calculator input#angle-of-slope').on('keyup change', function () {
      let slopeAngle = $('.heavy-vehicle-calculator #angle-of-slope').val();
      $('.heavy-vehicle-calculator #angle-of-slope-percentage').val((Math.tan(slopeAngle * Math.PI / 180) * 100).toFixed(2));
      if (slopeAngle == 0) {
        $('.heavy-vehicle-calculator #angle-of-slope-ratio').val(0);
      } else {
        $('.heavy-vehicle-calculator #angle-of-slope-ratio').val((1 / (Math.tan(slopeAngle * Math.PI / 180))).toFixed(2));
      }
    });

    $('#motor-calculator-section.heavy-vehicle-calculator input#angle-of-slope-percentage').on('keyup change', function () {
      let slopeAngle = $('.heavy-vehicle-calculator #angle-of-slope-percentage').val();
      $('.heavy-vehicle-calculator #angle-of-slope').val(((Math.atan(slopeAngle / 100)) * 180 / Math.PI).toFixed(0));

      if (slopeAngle == 0) {
        $('.heavy-vehicle-calculator #angle-of-slope-ratio').val(0);
      } else {
        $('.heavy-vehicle-calculator #angle-of-slope-ratio').val((100 / slopeAngle).toFixed(2));
      }
    });

    $('#motor-calculator-section.heavy-vehicle-calculator input#angle-of-slope-ratio').on('keyup change', function () {
      let slopeAngle = $('.heavy-vehicle-calculator #angle-of-slope-ratio').val();

      if (slopeAngle == 0) {
        $('.heavy-vehicle-calculator #angle-of-slope').val(0);
        $('.heavy-vehicle-calculator #angle-of-slope-percentage').val(0);
      } else {
        $('.heavy-vehicle-calculator #angle-of-slope').val(((Math.atan(1 / slopeAngle)) * 180 / Math.PI).toFixed(0));
        $('.heavy-vehicle-calculator #angle-of-slope-percentage').val((100 / slopeAngle).toFixed(2));
      }
    });
    // Slope Calculations

    // Listen for Input Number Field Changes on Calculator Page and Run Calculations, Validations
    $('#motor-calculator-section.automotive-calculator input').not('#motor-calculator-section .calculator-contact-form-wrp input , #motor-calculator-section .radio-wrp input').on('keyup change', function () {
      motorCalculator();
      // $(this).valid();
    });

    $('#motor-calculator-section.heavy-vehicle-calculator input').not('#motor-calculator-section .calculator-contact-form-wrp input , #motor-calculator-section .radio-wrp input').on('keyup change', function () {
      motorCalculator();
      // $(this).valid();
    });

    // Listen for Radio Motor Changes on Calculator Page and Run Calculations without Validations
    $('#motor-calculator-section.automotive-calculator .radio-wrp input').on('keyup change', function () {
      motorCalculator();
    });

    $('#motor-calculator-section.heavy-vehicle-calculator .radio-wrp input').on('keyup change', function () {
      motorCalculator();
    });

    // Listen for Input Changes on Product Listing Page and Run Calculations, Validations
    $('.motor-items-wrp .motor-item input').on('keyup change', function () {
      let calculatorSection = $(this).parents('.motor-item');
      motorListingCalculator(calculatorSection);
      // $(this).valid();
    });

    // Run Calculations in Calculations Page on Page Load
    $('.motor-items-wrp .motor-item').each(function () {
      let test = $(this);
      motorListingCalculator(test);
    });

    // Calculations Page Proceed Button Click
    $('#motor-calculator-section.automotive-calculator #calculator-proceed-button').click(function (e) {
      e.preventDefault();

      $('#motor-calculator-section.automotive-calculator').removeClass('step-1');
      $('#motor-calculator-section.automotive-calculator').addClass('step-2');
      $('#motor-calculator-section.automotive-calculator #motor-selection').css({ 'display': 'none' });
      let selectedMotor = $('#motor-calculator-section.automotive-calculator input[name="motor-select-automotive"]:checked').val();
      let selectedMotorSeperated = selectedMotor.split('-');
      let selectedMotorId = parseFloat(selectedMotorSeperated[1]);

      $('#motor-calculator-section.automotive-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
        let imageWrp = $(this).find('.img-wrp');
        if ($(this).is(`#motor-${selectedMotorId}`)) {
          $(this).fadeIn(500);
          $('#motor-calculator-section.automotive-calculator .change-btn-wrp').appendTo(imageWrp);
          $('#motor-calculator-section.automotive-calculator .change-btn-wrp').removeClass('d-none');
        }
      });

      $('#motor-calculator-section.automotive-calculator .calculator-inner-wrp').css({ 'display': 'none' });
      $('#motor-calculator-section.automotive-calculator .calculator-form-wrp').fadeIn(500);
    });

    // Calculations Page Goto Edit Button CLick
    $('#motor-calculator-section.automotive-calculator #goto-edit-calculator').click(function (e) {
      e.preventDefault();

      $('#motor-calculator-section.automotive-calculator').addClass('step-1');
      $('#motor-calculator-section.automotive-calculator').removeClass('step-2');
      $('#motor-calculator-section.automotive-calculator .calculator-page .wpcf7-form-control-wrap').children('.wpcf7-not-valid-tip').css('display', 'none');
      $('#motor-calculator-section.automotive-calculator .calculator-contact-form-wrp').find('.wpcf7-response-output').css('display', 'none');

      $('#motor-calculator-section.automotive-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
        $(this).css('display', 'none');
      });

      $('#motor-calculator-section.automotive-calculator #motor-selection').fadeIn(500);

      $('#motor-calculator-section.automotive-calculator .calculator-inner-wrp').fadeIn(500);
      $('#motor-calculator-section.automotive-calculator .calculator-form-wrp').css({ 'display': 'none' })
    });

    // Calculations Page CF7 On Mail Sent Function
    if (document.querySelector('#motor-calculator-section.automotive-calculator .calculator-contact-form-wrp .wpcf7')) {
      var wpcf7Elm = document.querySelector('#motor-calculator-section.automotive-calculator .calculator-contact-form-wrp .wpcf7');

      wpcf7Elm.addEventListener('wpcf7submit', function () {
        $('#motor-calculator-section.automotive-calculator .calculator-page .wpcf7-form-control-wrap').children('.wpcf7-not-valid-tip').css('display', 'block');
        $('#motor-calculator-section.automotive-calculator .calculator-contact-form-wrp').find('.wpcf7-response-output').css('display', 'block');
      }, false);

      wpcf7Elm.addEventListener('wpcf7mailsent', function () {
        let selectedMotor = $('#motor-calculator-section.automotive-calculator input[name="motor-select-automotive"]:checked').val();
        let selectedMotorSeperated = selectedMotor.split('-');
        let selectedMotorId = parseFloat(selectedMotorSeperated[1]);

        $('#motor-calculator-section.automotive-calculator .motor-datasheets-wrp .motor-datasheet-item').each(function () {
          if ($(this).is(`#motor-${selectedMotorId}`)) {
            // $(this).removeClass('d-none');
            $(this).fadeIn(500);
          }
        });

        $('#motor-calculator-section.automotive-calculator .calculator-form-wrp').css({ 'display': 'none' })
        $('#motor-calculator-section.automotive-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
          // $(this).addClass('d-none');
          $(this).css({ 'display': 'none' });
        });
      }, false);
    }

    // Calculations Page Proceed Button Click Heavy Vehicle
    $('#motor-calculator-section.heavy-vehicle-calculator #calculator-proceed-button').click(function (e) {
      e.preventDefault();

      $('#motor-calculator-section.heavy-vehicle-calculator').removeClass('step-1');
      $('#motor-calculator-section.heavy-vehicle-calculator').addClass('step-2');
      $('#motor-calculator-section.heavy-vehicle-calculator #motor-selection').css({ 'display': 'none' });
      let selectedMotor = $('#motor-calculator-section.heavy-vehicle-calculator input[name="motor-select-heavy-vehicle"]:checked').val();
      let selectedMotorSeperated = selectedMotor.split('-');
      let selectedMotorId = parseFloat(selectedMotorSeperated[1]);

      $('#motor-calculator-section.heavy-vehicle-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
        let imageWrp = $(this).find('.img-wrp');
        if ($(this).is(`#motor-${selectedMotorId}`)) {
          $(this).fadeIn(500);
          $('#motor-calculator-section.heavy-vehicle-calculator .change-btn-wrp').appendTo(imageWrp);
          $('#motor-calculator-section.heavy-vehicle-calculator .change-btn-wrp').removeClass('d-none');
        }
      });

      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-inner-wrp').css({ 'display': 'none' });
      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-form-wrp').fadeIn(500);
    });

    // Calculations Page Goto Edit Button CLick
    $('#motor-calculator-section.heavy-vehicle-calculator #goto-edit-calculator').click(function (e) {
      e.preventDefault();

      $('#motor-calculator-section.heavy-vehicle-calculator').addClass('step-1');
      $('#motor-calculator-section.heavy-vehicle-calculator').removeClass('step-2');
      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-page .wpcf7-form-control-wrap').children('.wpcf7-not-valid-tip').css('display', 'none');
      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-contact-form-wrp').find('.wpcf7-response-output').css('display', 'none');

      $('#motor-calculator-section.heavy-vehicle-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
        $(this).css('display', 'none');
      });

      $('#motor-calculator-section.heavy-vehicle-calculator #motor-selection').fadeIn(500);

      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-inner-wrp').fadeIn(500);
      $('#motor-calculator-section.heavy-vehicle-calculator .calculator-form-wrp').css({ 'display': 'none' })
    });

    // Calculations Page CF7 On Mail Sent Function
    if (document.querySelector('#motor-calculator-section.heavy-vehicle-calculator .calculator-contact-form-wrp .wpcf7')) {
      var wpcf7ElmHeavyVehicle = document.querySelector('#motor-calculator-section.heavy-vehicle-calculator .calculator-contact-form-wrp .wpcf7');

      wpcf7ElmHeavyVehicle.addEventListener('wpcf7submit', function () {
        $('#motor-calculator-section.heavy-vehicle-calculator .calculator-page .wpcf7-form-control-wrap').children('.wpcf7-not-valid-tip').css('display', 'block');
        $('#motor-calculator-section.heavy-vehicle-calculator .calculator-contact-form-wrp').find('.wpcf7-response-output').css('display', 'block');
      }, false);

      wpcf7ElmHeavyVehicle.addEventListener('wpcf7mailsent', function () {
        let selectedMotor = $('#motor-calculator-section.heavy-vehicle-calculator input[name="motor-select-heavy-vehicle"]:checked').val();
        let selectedMotorSeperated = selectedMotor.split('-');
        let selectedMotorId = parseFloat(selectedMotorSeperated[1]);

        $('#motor-calculator-section.heavy-vehicle-calculator .motor-datasheets-wrp .motor-datasheet-item').each(function () {
          if ($(this).is(`#motor-${selectedMotorId}`)) {
            // $(this).removeClass('d-none');
            $(this).fadeIn(500);
          }
        });

        $('#motor-calculator-section.heavy-vehicle-calculator .calculator-form-wrp').css({ 'display': 'none' })
        $('#motor-calculator-section.heavy-vehicle-calculator .motor-details-wrp .form-motor-item-wrp').each(function () {
          // $(this).addClass('d-none');
          $(this).css({ 'display': 'none' });
        });
      }, false);
    }

    // Insights & News Load More
    $(document).ready(function () {
      $('.insights-item-v1').slice(0, 1).show();
      $('.insights-item-v2').slice(0, 1).show();
      if ($('.insights-item-v1:hidden').length != 0 || $('.insights-item-v2:hidden').length != 0) {
        $('#loadMoreInsights').show();
      } else {
        $('#loadMoreInsights').hide();
        $('#loadMoreInsights').text('').fadeOut('slow');
        $('#loadMoreInsights').addClass('load-more-end');
      }
      $('#loadMoreInsights').on('click', function (e) {
        e.preventDefault();
        $('.insights-item-v1:hidden').slice(0, 1).slideDown();
        $('.insights-item-v2:hidden').slice(0, 1).slideDown();
        if ($('.insights-item-v1:hidden').length == 0) {
          $('#loadMoreInsights').text('No More to view').fadeOut('slow');
          $('#loadMoreInsights').addClass('load-more-end');
        }
      });
    });

    //map-section popup+
    $('.contact-map-section #map-address-wrp .title-wrp-outer').each(function () {
      $(this).click(function () {
        $('.map-details').slideUp();
        $(this).next('.map-details').slideDown();
      });
    });

    $('.contact-map-section .flickity-button').click(function () {
      $('.show-address .map-details').slideUp();
      $('.item-wrp').each(function () {
        $(this).removeClass('show-address');
      });
    });
    //map-section popup

    // Product Listing Button Action
    $('.product-listing-view-datasheet').click(function (e) {
      e.preventDefault();
      $(this).slideUp();
      $(this).siblings('.product-listing-view-datasheet-content').slideDown();
    });

    var wpcf7ElmListing = document.querySelectorAll('.products-listing-section .motor-items-wrp .wpcf7');

    for (let i = 0; i < wpcf7ElmListing.length; i++) {
      wpcf7ElmListing[i].addEventListener('wpcf7mailsent', function () {
        window.open($(this).parent().siblings('.datasheet-link').attr('href'));
      }, false);
    }
    // Product Listing Button Action

    // Insights & News Mobile Load More
    $(document).ready(function () {
      $('.insights-item-mobile').slice(0, 2).show();
      if ($('.insights-item-mobile:hidden').length != 0) {
        $('#loadMoreInsightsMobile').show();
      } else {
        $('#loadMoreInsightsMobile').hide();
        $('#loadMoreInsightsMobile').text('').fadeOut('slow');
        $('#loadMoreInsightsMobile').addClass('load-more-end');
      }
      $('#loadMoreInsightsMobile').on('click', function (e) {
        e.preventDefault();
        $('.insights-item-mobile:hidden').slice(0, 2).slideDown();
        if ($('.insights-item-mobile:hidden').length == 0) {
          $('#loadMoreInsightsMobile').text('No More to view').fadeOut('slow');
          $('#loadMoreInsightsMobile').addClass('load-more-end');
        }
      });
    });

    // toggle class on hamburger icon click
    $('.mobile-burger-icon').click(function () {
      $('body, .mobile-burger-icon').toggleClass('show-menu');
    });

    // mobile sub menu navigation
    // level 1
    $('.mobile-menu .nav > li.menu-item-has-children').each(function () {
      $(this).append('<span class="sub-menu-click"></span>');
      $(this).find('> .sub-menu-wrap > .sub-menu, > .mega-menu-wrp > .mega-menu').prepend('<div class="return-link">' + $(this).find('> a').text() + '</div>');
      $(this).find('> .sub-menu-click').click(function (e) {
        e.preventDefault();
        $(this).siblings('.sub-menu-wrap, .mega-menu-wrp').toggleClass('show-menu');
      });
    });

    // level 2
    $('.mobile-menu .nav > li.menu-item-has-children > .sub-menu-wrap li.menu-item-has-children').each(function () {
      $(this).find('> .sub-menu-wrap > .sub-menu').prepend('<div class="return-link">' + $(this).find('> a').text() + '</div>');
      $(this).find('> a').click(function (e) {
        e.preventDefault();
        $(this).siblings('.sub-menu-wrap').toggleClass('show-menu');
      });
    });

    // return link click
    $('.return-link').each(function () {
      $(this).click(function () {
        $(this).parent().parent('.sub-menu-wrap, .mega-menu-wrp').removeClass('show-menu');
      });
    });

    // set header height to sticky overlay
    $('.sticky-overlay').outerHeight($('.header').outerHeight());


    // Cookie Policy Set up
    //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
    if (getCookie('popupCookie') != 'submited') {
      if (getCookie('popupCookie') != 'closed') {
        setTimeout(function () { $('.cookie-wrp').css('display', 'block').hide().fadeIn(); }, 3000);
      }
    }

    $('a.close-cookie').click(function () {
      $('.cookie-wrp').fadeOut();
      //sets the coookie to one minute (.00069444444) if the popup is closed (whole numbers = days)
      setCookie('popupCookie', 'closed', 1);
    });

    $('a.accept-cookie').click(function () {
      $('.cookie-wrp').fadeOut();
      //sets the coookie to five minutes (.0034722222 ) if the popup is submited (whole numbers = days)
      setCookie('popupCookie', 'submited', 100);
    });
    // Cookie Policy Set up

    formScripts();
    cardSectionGridSlider();
    cardSectionSlider();
    cardSectionTimeline();
    gallerySectionSlider();
    jqueryViewer('#gallery-images-viewer-v2');
    jqueryViewer('#gallery-images-viewer-v1');
    fullWidthVideoPlayer();
    videoPopupPlayer();
    delayHomeBannerVideo();
    slideUpMenuOption();
    footerTicker();
    productSectionGridSlider();
    productSectionSlider();
    checkSectionsForGaps();
    productListingItem();
    testimonialsSlider();
    customMotorForm();
    newCalculator();
    motorCalculator();
    marineCalculator();
    fanPowerCalculator();
    pumpAndFanPowerCalculator(fanPumpCalculatorJSON, fanPumpMotorDataJSON);
    setTimeout(scrollToSection, 100);
    cardSectionVideoPlay();
    editorContentAdditions();
    twoColumnSectionVideoPlay();
    dataSectionLinkCollect();
    eGyptCalendarLinkCollect();
    pumpAndFanLinkCollect();
    setNavHeight();
    setEqualHeight();
    UnitNameOnClick();
    unitSelection('initial');
    mainProductSelection('initial');
    productImageSectionSlider();
    productOtherApplication();
    updateDotPositions();
    productPageProductNameSlider();
    updateFeatures();
    productUnitNameGridSlider();

    var hammer = new Hammer($('body')[0]);
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

    hammer.on('swipeup', function () {
      // console.log('Swipe up detected');
    });

    hammer.on('swipedown', function () {
      // console.log('Swipe down detected');
    });
  },
};

$(window).on('hashchange', scrollToSection);

$(window).on('resize', function () {
  let mapSectionWidthResize = checkMapWidth();

  if (mapSectionWidthResize == true) {
    $('#map-address-wrp').addClass('flickity-now');
    mapSectionSlider()
  }

  setNavHeight();
  setEqualHeight();

  $('.fcp-testimonials-section .testimonials-wrp, .cards-section.v1 .cards-wrp, .cards-section.v2 .cards-wrp, .cards-section.v3 .cards-wrp, .products-section.v1 .products-wrp, .products-section.v2 .products-wrp, .gallery-section.v1 .gallery-wrapper, .product-image-section .section-inner-wrp .image-gallery.has-4, .other-applications-section .section-inner-wrp .applications-wrp.slider, .product-page.product-section .section-inner-wrp .units-wrp .units-names-wrp, .product-page.product-section .section-inner-wrp .units-wrp .images-wrp').flickity('resize');
});

(function () {
  var resizeTimeout;
  var lastWidth = window.innerWidth;
  var widthThreshold = 10; // px

  function runFunctions() {
    unitSelection('runFunctions');
    mainProductSelection('runFunctions');
    updateDotPositions();
    productPageProductNameSlider();
  }

  // Handle resize (only if width changes more than threshold)
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(function () {
      var currentWidth = window.innerWidth;

      if (Math.abs(currentWidth - lastWidth) > widthThreshold) {
        runFunctions();
        lastWidth = currentWidth;
      }
    }, 200); // debounce delay
  });

  // Handle orientation change separately
  window.addEventListener('orientationchange', function () {
    runFunctions();
    lastWidth = window.innerWidth; // update to new width after rotation
  });
})();

$(window).on('load', function () {
  $('.fcp-testimonials-section .testimonials-wrp, .cards-section.v1 .cards-wrp, .cards-section.v2 .cards-wrp, .cards-section.v3 .cards-wrp, .products-section.v1 .products-wrp, .products-section.v2 .products-wrp, .gallery-section.v1 .gallery-wrapper, .products-listing-section .product-carousel-nav, .products-listing-section .product-nav, .product-image-section .section-inner-wrp .image-gallery.has-4, .other-applications-section .section-inner-wrp .applications-wrp.slider, .product-page.product-section .section-inner-wrp .units-wrp .units-names-wrp, .product-page.product-section .section-inner-wrp .units-wrp .images-wrp').flickity('resize');
});

//map slider
function mapSectionSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 768px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $(
    '.contact-map-section .main-carousel.flickity-now'
  ).flickity({
    cellAlign: cellAlignValue,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    initialIndex: 2,
  });
}

function mapSectionSliderDestroy() {
  $('.contact-map-section .main-carousel.flickity-now').flickity('destroy');
}

// sticky menu
$(window).scroll(function () {
  var scroll = getCurrentScroll();
  if (scroll >= shrinkHeader) {
    $('body, .header-container').addClass('sticky-header');
  } else {
    $('body, .header-container').removeClass('sticky-header');
  }

  $('.sticky-overlay').outerHeight($('.header').outerHeight());
});

function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}
// sticky menu

function formScripts() {
  if ($('.form-dropdown')) {
    $('.form-dropdown').each(function () {
      var dropDownPlaceHolder = $('.dropdown-placeholder').html();
      $('.dropdown-placeholder').css('display', 'none');

      $(this).select2({
        dropdownParent: $(this).parent().parent(),
        placeholder: dropDownPlaceHolder,
      });
    });
  }

  if ($('.select2-calculator')) {
    $('.select2-calculator').each(function () {
      $(this).select2({
        dropdownParent: $(this).parent(),
      });
      $(this).parent().addClass('d-none');
    });
  }

  $('.wpcf7-form').each(function () {
    $('.button-wrp-outter').append($('.wpcf7-response-output'));
  })
}

function productImageSectionSlider() {
  $('.product-image-section .section-inner-wrp .image-gallery.has-4').flickity({
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
  });
}

function productOtherApplication() {
  $('.other-applications-section .section-inner-wrp .applications-wrp.slider').flickity({
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
    cellAlign: 'left',
  });
}

function UnitNameOnClick() {
  $('.product-page.product-section .unit-name-item').click(function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selectedProductName = urlParams.get('product');

    const newUnitParameter = $(this).find('.unit-name').text();
    const currentUrl = new URL(window.location.href);

    // console.log('selectedProductName : ', selectedProductName, 'newUnitParameter : ', newUnitParameter);
    currentUrl.searchParams.set('unit', newUnitParameter);

    if (selectedProductName == null) {
      const prductParameter = $('.product-page.product-section .main-product-item-outer')
        .first()
        .find('.product-name')
        .text();

      // console.log('prductParameter : ', prductParameter);
      currentUrl.searchParams.set('product', prductParameter);
    }

    window.history.replaceState({}, '', currentUrl);
  });
}

// Technical Documentation Popup Form Script - Start //

let downloadUrl;
let productName;

function dataSectionLinkCollect() {
  $('.technical-documentation-section td a').each(function () {
    let column = $(this).parent().attr('class') || 'no-column';
    let row = $(this).parent().parent().attr('class') || 'no-row';
    let itemID = 'item-' + row + '-' + column;
    let itemLink = $(this).attr('href');
    let product = $(this).closest('tr').find('.column-1').text().trim();

    $(this).attr('id', itemID).attr('href', '');

    // Attach click handler directly
    $('#' + itemID).on('click', function (e) {
      e.preventDefault();

      downloadUrl = itemLink;
      productName = product;

      $('#product-data-popup-form-wrp').slideDown('slow');
      $('#product-name-field').val(productName);
      $('#product-data-popup-form-wrp .wpcf7-response-output').html('');
      $('#product-data-popup-form-wrp .wpcf7-not-valid-tip').html('');
    });
  });
}

// $('.technical-documentation-section td a').on('click', function(e) {
//   e.preventDefault(); // stops the default action (opening the link)

//   // get product name from the same row
//   productName = $(this).closest('tr').find('.column-1').text().trim();
//   $('#product-data-popup-form-wrp').slideUp('slow');

//   downloadUrl = $(this).attr('href');

//   $('#product-data-popup-form-wrp').slideDown('slow');
//   $('#product-name-field').val(productName);
//   $('#product-data-popup-form-wrp .wpcf7-response-output').html('');
//   $('#product-data-popup-form-wrp .wpcf7-not-valid-tip').html('');
// });

function getFileExtension(url) {
  let cleanUrl = url.split('?')[0];
  let parts = cleanUrl.split('.');
  if (parts.length < 2) return '';
  return parts.pop();
}

$(document).on('wpcf7mailsent', function (event) {
  if ($(event.target).closest('.product-popup-form-wrp').length) {
    if (downloadUrl) {
      const link = document.createElement('a');
      link.href = downloadUrl;

      const urlParts = downloadUrl.split('/');
      const originalFileName = urlParts[urlParts.length - 1].split('?')[0]; // removes any query params
      const fileName = originalFileName || 'file.' + (getFileExtension(downloadUrl) || 'pdf');
      link.setAttribute('download', fileName);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Reset
      downloadUrl = '';
      productName = '';
    }
  }
});

$(document).ready(function () {
  // store values before submit
  let formValues = {};

  $(document).on('wpcf7beforesubmit', function (event) {
    if ($(event.target).closest('.product-popup-form-wrp').length) {
      formValues = {};
      $(event.target).find('input[type="text"], input[type="email"], input[type="tel"]').each(function () {
        formValues[$(this).attr('name')] = $(this).val();
      });
    }
  });


  // after successful submit
  $(document).on('wpcf7mailsent', function (event) {
    if ($(event.target).closest('.product-popup-form-wrp').length) {
      // console.log(formValues);
      event.preventDefault();
      setTimeout(function () {
        $(event.target).find('input[type="text"], input[type="email"], input[type="tel"]').each(function () {
          var fieldName = $(this).attr('name');
          if (formValues[fieldName] !== undefined) {
            $(this).val(formValues[fieldName]);
          }
        });
      }, 200);
    }

    setTimeout(function () {
      $('#product-data-popup-form-wrp').slideUp('slow');
    }, 1000);
  });
});

$('#form-seamless-integration-close-button').on('click', function () {
  $('#product-data-popup-form-wrp').slideUp('slow');
});

// Using same form for egypt calendar button functionality - start
function eGyptCalendarLinkCollect() {
  $('.information-wrp-item .button-wrp .download-cad-button').each(function () {
    let itemLink = $(this).attr('href');
    let product = $(this).attr('data-unit-name');

    $(this).attr('href', '');

    // Attach click handler directly
    $(this).on('click', function (e) {
      e.preventDefault();

      downloadUrl = itemLink;
      productName = product;

      $('#product-data-popup-form-wrp').slideDown('slow');
      $('#product-name-field').val(productName);
      $('#product-data-popup-form-wrp .wpcf7-response-output').html('');
      $('#product-data-popup-form-wrp .wpcf7-not-valid-tip').html('');
    });
  });
}
// Using same form for egypt calendar button functionality - end

// Technical Documentation Popup Form Script - End //


// product page --> product section scripts - Start //

function productPageProductNameSlider(functionRunLocation = null) {
  $('.product-page.product-section .section-inner-wrp .units-wrp .unit-item-outer.unit-slider').each(function () {
    var $this = $(this).find('.units-names-wrp');
    var $sliderA = $(this).find('.images-wrp');
    var $sliderB = $(this).find('.informations-wrp');

    var initialIndexValue;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selectedUnitName = urlParams.get('unit');
    const selectedProductName = urlParams.get('product');

    const selectedUnit = findUnitPosition(selectedUnitName, selectedProductName);

    if (typeof (selectedUnit) == 'number' && functionRunLocation == 'initial') {
      initialIndexValue = selectedUnit;
    } else {
      initialIndexValue = 1;
    }

    if (functionRunLocation == 'onChangeProduct') {
      var newUnitParameter;

      // Updates both productPageProductNameSlider and productUnitNameGridSlider
      if ($(`.unit-item-outer.${selectedProductName} .image-and-name-warpper .units-names-wrp-outer .unit-name-item`).length > 4) {
        newUnitParameter = $(`.unit-item-outer.${selectedProductName} .image-and-name-warpper .units-names-wrp-outer .unit-name-item.is-selected`).find('.unit-name').text();
      } else {
        if (window.matchMedia('(min-width: 768px)').matches) {
          newUnitParameter = $(`.unit-item-outer.${selectedProductName} .image-and-name-warpper .units-names-wrp-outer .unit-name-item.selected`).find('.unit-name').text();
        } else {
          newUnitParameter = $(`.unit-item-outer.${selectedProductName} .image-and-name-warpper .units-names-wrp-outer .unit-name-item.is-selected`).find('.unit-name').text();
        }
      }

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('unit', newUnitParameter);
      window.history.replaceState({}, '', currentUrl);
    }


    // Initialize Flickity on this specific wrapper
    var mainSlider = new Flickity($this[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: !window.matchMedia('(min-width: 768px)').matches,
      cellAlign: 'center',
      draggable: !window.matchMedia('(min-width: 768px)').matches,
      initialIndex: initialIndexValue,
    });

    // First synced slider
    var sliderA = new Flickity($sliderA[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      cellAlign: 'left',
      lazyLoad: true,
      draggable: false,
      selectedAttraction: 1, // default 0.025, higher = faster snap
      friction: 1,           // default 0.28, higher = stops animation
    });

    // Second synced slider
    var sliderB = new Flickity($sliderB[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      cellAlign: 'left',
      lazyLoad: true,
      draggable: false,
      selectedAttraction: 1, // default 0.025, higher = faster snap
      friction: 1,
    });

    mainSlider.on('select', function () {
      var index = mainSlider.selectedIndex;
      sliderA.select(index);
      sliderB.select(index);
    });

    if (window.matchMedia('(min-width: 768px)').matches) {
      new FlickityTransformer(mainSlider, [
        {
          name: 'translateY',
          stops: [
            [-282, 65],
            [-188, 0],
            [-94, -45],
            [0, -65],
            [94, -45],
            [188, 0],
            [282, 65],
          ],
        },
      ]);

      // sliderB.on('scroll', () => {
      //   sliderA.slides.forEach((slide, i) => {
      //     const x = sliderA.slides[i].target + sliderA.x;
      //     const distance = Math.abs(x);

      //     // Map distance to opacity (0.5 at far, 1 at center)
      //     const maxDistance = 478;
      //     const opacity = 1 - Math.min(distance / maxDistance, 1) * 0.3;

      //     slide.cells.forEach(cell => {
      //       cell.element.style.opacity = opacity;
      //     });
      //   });
      // });

      // sliderA.on('scroll', () => {
      //   // You could base this on the first slide's width
      //   const maxDistance = sliderA.slides[0].width; // dynamic based on cell size

      //   sliderA.slides.forEach((slide) => {
      //     const x = slide.target + sliderA.x;
      //     const distance = Math.abs(x);

      //     // Calculate opacity dynamically
      //     const opacity = 1 - Math.min(distance / maxDistance, 1) * 0.5;

      //     slide.cells.forEach(cell => {
      //       cell.element.style.opacity = opacity;
      //     });
      //   });
      // });

      // Force Flickity to recalc layout

      // Initialize Hammer on this specific Flickity viewport
      var viewport = $this.find('.flickity-viewport')[0];
      if (!viewport) return; // skip if not found

      // Disable Hammer's default CSS injection
      Hammer.defaults.cssProps = {};

      // Allow native vertical scroll
      viewport.style.touchAction = 'pan-y';

      var hammer = new Hammer(viewport);
      hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

      hammer.on('swipe', function (e) {
        var speed = Math.abs(e.velocityY);
        var slidesToMove = Math.min(Math.ceil(speed * 1.5), mainSlider.slides.length - 1);

        if (e.direction === Hammer.DIRECTION_UP) {
          mainSlider.select(mainSlider.selectedIndex + slidesToMove);
        }
        if (e.direction === Hammer.DIRECTION_DOWN) {
          mainSlider.select(mainSlider.selectedIndex - slidesToMove);
        }
      });

      //scroll on mouse hover

      $this.find('.flickity-viewport')
        .off('wheel') // remove previous bindings
        .on('wheel', function (e) {
          e.preventDefault(); // prevent page scrolling

          // console.log('scrolled once');

          var delta = e.originalEvent.deltaY || e.originalEvent.wheelDelta;
          if (!delta) return;

          if (delta > 0) {
            mainSlider.select(mainSlider.selectedIndex + 1); // scroll down → next slide
          } else {
            mainSlider.select(mainSlider.selectedIndex - 1); // scroll up → previous slide
          }

          const currentSlide = $(mainSlider.selectedElement).find('.unit-name').text();
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('unit', currentSlide);
          window.history.replaceState({}, '', currentUrl);
        });
    } else {
      new FlickityTransformer(mainSlider, [
        {
          name: 'translateY',
          stops: [
            [-282, 0],
            [0, 0],
            [282, 0],
          ],
        },
      ]);

      $this.find('.flickity-viewport')
        .off('wheel')
    }

    $this.find('.unit-name-item .name-wrp').on('click', function () {
      var cellElem = $(this).closest('.unit-name-item')[0]; // the actual Flickity cell

      var index = mainSlider.cells.findIndex(function (cell) {
        return cell.element === cellElem;
      });

      if (index !== -1) mainSlider.select(index);
    });

    mainSlider.resize();
    mainSlider.reposition();
    sliderA.resize();
    sliderA.reposition();
    sliderB.resize();
    sliderB.reposition();
  });
}

function updateDotPositions() {
  if (window.matchMedia('(min-width: 768px)').matches) {
    $('.dot-wrap').each(function () {
      var $dotWrap = $(this);
      var $dots = $dotWrap.find('.dot');
      var count = $dots.length;
      if (count === 0) return;

      var halfHeight = ($dotWrap[0].offsetHeight / 2) - 7;
      var rotationStep, rotationStart;

      if (count === 5) {
        rotationStep = 116 / count;
        rotationStart = -60;
      } else if (count === 4) {
        rotationStep = 78 / count;
        rotationStart = -40;
      } else { // less than 4
        rotationStep = 58 / count;
        rotationStart = -30;
      }

      $dots.each(function (index, el) {
        var rotation = rotationStart + rotationStep * (index + 0.5);
        el.style.transform = 'rotate(' + rotation + 'deg) translateX(' + halfHeight + 'px)';
      });
    });
  }
}

function findUnitPosition(unitName, productName) {
  let count = 0;
  let innerHtml = $(`.unit-item-outer.${productName} .unit-name-item`);

  innerHtml.each(function () {
    const title = $(this).find('.unit-name').text();
    if (title == unitName) {
      return false;
    }
    count++;
  })

  return count == innerHtml.length ? null : count;
}

function findGridUnitPosition(unitName, productName, wrapper) {
  if (!wrapper.hasClass(productName)) {
    return null;
  }

  let count = 0;
  let innerHtml = $(`.unit-item-outer.${productName} .unit-name-item`);

  innerHtml.each(function () {
    const title = $(this).find('.unit-name').text();
    if (title == unitName) {
      return false;
    }
    count++;
  })

  return count == innerHtml.length ? null : count;
}

function unitSelection(functionRunLocation = null) {
  // Desktop Size
  if (window.matchMedia('(min-width: 768px)').matches) {
    // Handle clicks
    $(document).on('click', '.unit-name-item', function () {
      var $wrapper = $(this).closest('.unit-item-outer');
      var index = $(this).index();
      var unitCount = $wrapper.find('.unit-name-item').length;

      if (unitCount < 5) {
        $wrapper.find('.unit-name-item, .image-wrp, .information-wrp-item, .dot-wrap .dot').removeClass('selected');

        $wrapper.find('.unit-name-item').eq(index).addClass('selected');
        $wrapper.find('.image-wrp').eq(index).addClass('selected');
        $wrapper.find('.information-wrp-item').eq(index).addClass('selected');
        $wrapper.find('.dot-wrap .dot').eq(index).addClass('selected');

        // const unitParameter = $wrapper.find('.unit-name-item').eq(index).find('.unit-name').text();
        // const currentUrl = new URL(window.location.href);
        // currentUrl.searchParams.set('unit', unitParameter);
        // window.history.replaceState({}, '', currentUrl);
      }
    });

    if (functionRunLocation == 'onChangeProduct') {
      // On Change product, Select Units
      $('.unit-item-outer').each(function () {
        var $wrapper = $(this);
        var unitCount = $wrapper.find('.unit-name-item').length;
        const unitItems = $wrapper.find('.unit-name-item');
        const selectedUnitIndex = unitItems.filter('.selected').index();

        if (unitCount < 5) {
          $wrapper.find('.unit-name-item, .image-wrp, .information-wrp-item, .dot-wrap .dot').removeClass('selected');
          $wrapper.find('.unit-name-item').eq(selectedUnitIndex).addClass('selected');
          $wrapper.find('.image-wrp').eq(selectedUnitIndex).addClass('selected');
          $wrapper.find('.information-wrp-item').eq(selectedUnitIndex).addClass('selected');
          $wrapper.find('.dot-wrap .dot').eq(selectedUnitIndex).addClass('selected');
        }

        const unitParameter = $('.unit-item-outer.selected .unit-name-item.selected .unit-name').text();
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('unit', unitParameter);
        window.history.replaceState({}, '', currentUrl);
      });
    } else {
      // Initial selection on page load
      $('.unit-item-outer').each(function () {
        var $wrapper = $(this);
        var unitCount = $wrapper.find('.unit-name-item').length;

        if (unitCount < 5) {
          // decide initial index
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const selectedUnitName = urlParams.get('unit');
          const selectedProductName = urlParams.get('product');

          const selectedUnit = findGridUnitPosition(selectedUnitName, selectedProductName, $wrapper);
          var initialIndex;

          if (typeof (selectedUnit) == 'number' && functionRunLocation == 'initial') {
            initialIndex = selectedUnit;
          } else {
            initialIndex = unitCount < 4 ? 0 : 1;
          }

          $wrapper.find('.unit-name-item, .image-wrp, .information-wrp-item, .dot-wrap .dot').removeClass('selected');
          $wrapper.find('.unit-name-item').eq(initialIndex).addClass('selected');
          $wrapper.find('.image-wrp').eq(initialIndex).addClass('selected');
          $wrapper.find('.information-wrp-item').eq(initialIndex).addClass('selected');
          $wrapper.find('.dot-wrap .dot').eq(initialIndex).addClass('selected');
        }
      });
    }
  }
}

function findProductPosition(productName) {
  let count = 0;
  $('.main-product-item-outer').each(function () {
    const title = $(this).find('.product-name').text();
    if (title == productName) {
      return false;
    }
    count++;
  })

  return count == $('.main-product-item-outer').length ? null : count;
}

function mainProductSelection(functionRunLocation = null) {
  // Handle clicks
  $(document).on('click', '.main-product-item-outer', function () {
    var $wrapper = $(this).closest('.product-page.product-section');
    var index = $(this).index();

    const productParameter = $(this).find('.product-name').text();
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('product', productParameter);
    window.history.replaceState({}, '', currentUrl);

    $wrapper.find('.main-product-item-outer, .units-wrp .unit-item-outer').removeClass('selected');
    $wrapper.find('.main-product-item-outer').eq(index).addClass('selected');
    $wrapper.find('.units-wrp .unit-item-outer').eq(index).addClass('selected');

    updateDotPositions();
    unitSelection('onChangeProduct');
    productPageProductNameSlider('onChangeProduct');
    productUnitNameGridSlider('onChangeProduct');
  });

  // Initial selection on page load
  $('.product-page.product-section').each(function () {
    var $wrapper = $(this);
    // var initialIndex = 0;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selectedProductName = urlParams.get('product');

    const selectedProduct = findProductPosition(selectedProductName);

    var initialIndex;
    if (selectedProduct && typeof (selectedProduct) == 'number' && functionRunLocation == 'initial') {
      initialIndex = selectedProduct;
    } else {
      initialIndex = 0;
    }

    $wrapper.find('.main-product-item-outer, .units-wrp .unit-item-outer').removeClass('selected');
    $wrapper.find('.main-product-item-outer').eq(initialIndex).addClass('selected');
    $wrapper.find('.units-wrp .unit-item-outer').eq(initialIndex).addClass('selected');

    updateDotPositions();
    productPageProductNameSlider(functionRunLocation);
    productUnitNameGridSlider(functionRunLocation);
  });
}

function productUnitNameGridSlider(functionRunLocation = null) {
  $('.product-page.product-section .section-inner-wrp .units-wrp .unit-item-outer.unit-tab').each(function () {
    var $wrapGridMobile = $(this);
    var $slider = $wrapGridMobile.find('.mobile-slider');
    var $imageGridMobile = $wrapGridMobile.find('.images-wrp');
    var $infoGridMobile = $wrapGridMobile.find('.informations-wrp'); // added

    if (!$slider.length) return;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const selectedUnitName = urlParams.get('unit');
    const selectedProductName = urlParams.get('product');

    const selectedUnit = findUnitPosition(selectedUnitName, selectedProductName, $wrapGridMobile);
    var initialIndex;

    if (typeof (selectedUnit) == 'number' && functionRunLocation == 'initial') {
      initialIndex = selectedUnit;
    } else {
      initialIndex = 1;
    }

    var mobilegridslider = new Flickity($slider[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      watchCSS: true,
      initialIndex: initialIndex,
    });

    function syncSelection(index) {
      // images
      $imageGridMobile.find('.image-wrp').removeClass('selected')
        .eq(index).addClass('selected');

      // informations
      $infoGridMobile.find('.information-wrp-item').removeClass('selected')
        .eq(index).addClass('selected');
    }

    mobilegridslider.on('select', function () {
      const index = mobilegridslider.selectedIndex;

      syncSelection(index);

      // const currentSlide = $(mobilegridslider.selectedElement).find('.unit-name').text();
      // const currentUrl = new URL(window.location.href);
      // currentUrl.searchParams.set('unit', currentSlide);
      // window.history.replaceState({}, '', currentUrl);
    });

    mobilegridslider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
      if (typeof cellIndex === 'number') {
        mobilegridslider.select(cellIndex);
        syncSelection(cellIndex);
      }
    });

    mobilegridslider.resize();
    mobilegridslider.reposition();
  });
}


function updateFeatures() {
  let scrollTop = $(window).scrollTop();
  let viewportCenter = scrollTop + ($(window).height() / 2);

  $('.product-page.product-section .main-products-wrp').children().each(function () {
    let $el = $(this);
    let $features = $el.find('.features-wrp');

    if (window.matchMedia('(max-width: 767px)').matches) {
      let elementTop = $el.offset().top;
      let elementHeight = $el.outerHeight();
      let elementCenter = elementTop + (elementHeight / 2);

      if (!$features.data('initialHeight')) {
        $features.data('initialHeight', $features.outerHeight());
        $features.css({
          height: 0,
          opacity: 0,
          overflow: 'hidden',
          transition: 'all 0.5s ease-in-out',
        });
      }

      let elementFeatureHeight = $features.data('initialHeight');

      if (Math.abs(elementCenter - viewportCenter) < 200) {
        $el.addClass('passed-center');
        $features.css({
          height: elementFeatureHeight,
          opacity: 1,
        });
      } else {
        $el.removeClass('passed-center');
        $features.css({
          height: 0,
          opacity: 0,
        });
      }
    } else {
      $el.removeClass('passed-center');
      $features.css({
        height: '',
        opacity: '',
        overflow: '',
        transition: '',
      });
    }
  });
}

// Trigger on scroll and resize
$(window).on('scroll resize', updateFeatures);

// product page --> product section scripts - end //

function cardSectionGridSlider() {
  $('.cards-section.v1 .section-inner-wrp .cards-wrp').flickity({
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
  });
}

function cardSectionVideoPlay() {
  $('.card-video-wrp').each(function () {
    $(this).parent().hover(
      function () {
        // Add class to trigger CSS changes and play video
        $(this).children('.card-video-wrp').addClass('hovering');
        $(this).find('video')[0].play();
        $(this).find('video')[0].muted = false;
      },
      function () {
        // Remove class to revert CSS changes and pause video
        $(this).children('.card-video-wrp').removeClass('hovering');
        $(this).find('video')[0].pause();
        $(this).find('video')[0].muted = true;
      }
    );
  });
}

function twoColumnSectionVideoPlay() {
  $('.two-column-video-wrp').each(function () {
    $(this).parent().hover(
      function () {
        // Add class to trigger CSS changes and play video
        $(this).children('.two-column-video-wrp').addClass('hovering');
        $(this).find('video')[0].play();
        $(this).find('video')[0].muted = false;
      },
      function () {
        // Remove class to revert CSS changes and pause video
        $(this).children('.two-column-video-wrp').removeClass('hovering');
        $(this).find('video')[0].pause();
        $(this).find('video')[0].muted = true;
      }
    );
  });
}

function cardSectionSlider() {
  $('.cards-section.v2').each(function () {
    var cellAlignValue = '';

    if (matchMedia('screen and (max-width: 768px)').matches) {
      cellAlignValue = 'center';
    } else {
      cellAlignValue = 'left';
    }

    $(this).find('.cards-wrp').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: cellAlignValue,
    });

    $(this).find('.flickity-page-dots').appendTo($(this).find('.pagination-wrp'));
    $(this).find('.flickity-button').appendTo($(this).find('.pagination-wrp'));
  });
}

function cardSectionTimeline() {
  $('.cards-section.v3').each(function () {
    var cellAlignValue = '';

    if (matchMedia('screen and (max-width: 768px)').matches) {
      cellAlignValue = 'center';
    } else {
      cellAlignValue = 'left';
    }

    $(this).find('.cards-wrp').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: false,
      cellAlign: cellAlignValue,
      groupCells: 1,
      contain: true,
    });

    $(this).find('.flickity-page-dots').appendTo($(this).find('.pagination-wrp'));
    $(this).find('.flickity-button').appendTo($(this).find('.pagination-wrp'));
  });
}

function productSectionGridSlider() {
  $('.products-section.v1 .section-inner-wrp .products-wrp').flickity({
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
  });
}

function productSectionSlider() {
  $('.products-section.v2').each(function () {
    var cellAlignValue = '';

    if (matchMedia('screen and (max-width: 768px)').matches) {
      cellAlignValue = 'center';
    } else {
      cellAlignValue = 'left';
    }

    $(this).find('.products-wrp').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: cellAlignValue,
    });

    $(this).find('.flickity-page-dots').appendTo($(this).find('.pagination-wrp'));
    $(this).find('.flickity-button').appendTo($(this).find('.pagination-wrp'));
  });
}

function testimonialsSlider() {
  $('.fcp-testimonials-section').each(function () {
    $('.fcp-testimonials-section .testimonials-wrp').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: 'center',
      adaptiveHeight: true,
    });

    $('.fcp-testimonials-section .testimonials-wrp').find('.flickity-button').appendTo($('.fcp-testimonials-section .testimonials-wrp-outer').find('.flickity-wrp'));
  });
}

function gallerySectionSlider() {
  $('.gallery-section.v1').each(function () {
    var cellAlignValue = '';

    if (matchMedia('screen and (max-width: 768px)').matches) {
      cellAlignValue = 'center';
    } else {
      cellAlignValue = 'left';
    }

    $(this).find('.gallery-wrp-slider').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: cellAlignValue,
    });

    $(this).find('.flickity-page-dots').appendTo($(this).find('.pagination-wrp'));
    $(this).find('.flickity-button').appendTo($(this).find('.pagination-wrp'));
  });
}

function productListingItem() {

  var counter = 0;
  $('.products-listing-section .sliders-wrp').each(function () {
    var productNavClassName = '.product-nav-' + counter;
    var mainCarousel = $(this).find(productNavClassName);
    var subCarousel = $(this).find('.product-carousel-nav-' + counter);

    // 1st carousel, main
    var mainCarouselProduct = new Flickity(mainCarousel[0], {
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
    });

    // 2nd carousel, navigation
    var subCarouselProduct = new Flickity(subCarousel[0], {
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    // Sync nav when main changes
    mainCarouselProduct.on('select', function () {
      var index = mainCarouselProduct.selectedIndex;
      subCarouselProduct.select(index);
    });

    // Click nav item to change main
    subCarouselProduct.on('staticClick', function (event, pointer, cellElement, cellIndex) {
      if (typeof cellIndex === 'number') {
        mainCarouselProduct.select(cellIndex);
      }
    });

    mainCarouselProduct.resize();
    mainCarouselProduct.reposition();
    subCarouselProduct.resize();
    subCarouselProduct.reposition();

    counter++;
  });
}

function setNavHeight() {
  const $navWrp = $('.mega-menu-wrp .products-nav-wrp.has-scroll');
  const $items = $('.mega-menu-wrp .product-item-wrp').slice(0, 4);

  if ($navWrp.length && $items.length) {
    let totalHeight = 0;
    $items.each(function () {
      totalHeight += $(this).outerHeight(true); // height + margins
    });

    $navWrp.height(totalHeight);
  }
}

function setEqualHeight() {
  const $apps = $('.mega-menu-wrp .application-name');

  if ($apps.length) {
    let maxHeight = 0;

    // Reset height to auto before recalculating (important for resize)
    $apps.css('height', 'auto');

    // Find max height
    $apps.each(function () {
      const height = $(this).outerHeight();
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Apply max height to all
    $apps.height(maxHeight);
  }
}

// Implementation of Jquery Viewer
function jqueryViewer(ulId) {
  var $galleryImages = $(ulId);

  $galleryImages.viewer({
    tooltip: 0,
    inline: false,
    toolbar: {
      zoomIn: {
        show: 1,
        size: 'large',
      },
      zoomOut: {
        show: 1,
        size: 'large',
      },
      oneToOne: 0,
      reset: 0,
      prev: {
        show: 1,
        size: 'large',
      },
      play: {
        show: 0,
        size: 'large',
      },
      next: {
        show: 1,
        size: 'large',
      },
      rotateLeft: 0,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    },
    title: 0,
    viewed: function () {
      $galleryImages.viewer('zoomTo', 1);
    },
  });
}
// Implementation of Jquery Viewer

// Full Width Video Player
function fullWidthVideoPlayer() {
  for (let i = 1; i <= $('.playvideo').length; i++) {
    let idName = 'play-video-' + i;
    let newIdName = 'video-iframe-' + i;
    $('.playvideo')[i - 1].setAttribute('id', idName);
    $('.iframe-video-auto-play-off')[i - 1].setAttribute('id', newIdName);
    $('#' + idName).click(function () {
      $(this).parent('.video-wrp').addClass('video-playing');
      if ($('#' + newIdName).hasClass('video-element')) {
        $('#' + newIdName).css('opacity', '1');
        $('#' + newIdName).get(0).play();
        $('#' + idName).css({
          'opacity': '0',
          'z-index': '-1',
        });
      } else {
        $('#' + newIdName).css('opacity', '1');
        $('#' + newIdName)[0].src += '&autoplay=1';
        $('#' + idName).css({
          'opacity': '0',
          'z-index': '-1',
        });
      }
    });
  }
}
// Full Width Video Player

// Popup Video Player for Two Column Section
function videoPopupPlayer() {
  var $videoSrc;
  $('.video-iframe-thumbnail').click(function () {
    $videoSrc = $(this).data('src');
  });

  $('#myModal').on('shown.bs.modal', function () {
    $('#video').attr(
      'src',
      $videoSrc + '?autoplay=1&mute=1&amp;modestbranding=1&amp;showinfo=0'
    );
  });

  $('#myModal').on('hide.bs.modal', function () {
    $('#video').attr('src', $videoSrc);
  });
}
// Popup Video Player for Two Column Section

// Delay Home Banner Video
function delayHomeBannerVideo() {
  setTimeout(function () {
    $('#home-banner-iframe').attr('src', $('#hidden-iframe-url').text());
    $('#home-banner-video').attr('src', $('#hidden-video-file').text());
  }, 3000);
}
// Delay Home Banner Video

function footerTicker() {
  if ($('.footer .email-ticker-wrp')) {
    // Play with this value to change the speed
    let tickerSpeed = 1;

    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector('.footer .email-ticker-wrp');

    const update = () => {
      if (isPaused) return;
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25,
    });

    flickity.x = 0;

    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
      isPaused = true;
    });

    update();
  }
}

// Header Scroll up Option
function slideUpMenuOption() {
  if ($('body > .header').hasClass('enable-scroll-up')) {
    var lastScrollTop = 0, delta = 15;
    var bannerHeight = $('.header').outerHeight();
    $(window).scroll(function () {
      var st = $(this).scrollTop();

      if (Math.abs(lastScrollTop - st) <= delta)
        return;
      if ((st > lastScrollTop) && (lastScrollTop > 0)) {
        // downscroll code
        $('body > .header, body > .sticky-overlay').css('top', (bannerHeight - (bannerHeight * 2)));
      } else {
        // upscroll code
        $('body > .header, body > .sticky-overlay').css('top', '0px');
      }
      lastScrollTop = st;
    });
  }
}
// Header Scroll up Option

function motorCalculator() {
  if ($('#motor-calculator-section.automotive-calculator input[name="motor-select-automotive"]:checked').val()) {
    // Get Selected Motor Details
    let motorRadio = $('#motor-calculator-section.automotive-calculator input[name="motor-select-automotive"]:checked').val();
    let motorValues = motorRadio.split('-');
    let motorId = parseFloat(motorValues[1]);
    let motorName = motorValues[2];

    $('#motor-calculator-section.automotive-calculator #form-motor-name').text(motorName);

    // Get Input Values and Check for Validation
    let frontalArea = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .car-frontal-area').val());
    if (frontalArea < 0) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .car-frontal-area').val('2.24');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .car-frontal-area').trigger('change');
    }
    let mass = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .mass-of-car').val());
    if (mass <= 0) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .mass-of-car').val('1635');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .mass-of-car').trigger('change');
    }
    let gearRatio = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .gear-ratio').val());
    if (gearRatio < 1) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .gear-ratio').val('3');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .gear-ratio').trigger('change');
    }
    let tyreRadius = parseFloat($('.motor-calculation .tyre-radius').val());
    if (tyreRadius < 0) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .tyre-radius').val('0.2515');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .tyre-radius').trigger('change');
    }
    let airDensity = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .air-density').val());
    if (airDensity < 0 || airDensity > 1.5) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .air-density').val('1.225');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .air-density').trigger('change');
    }
    let transmissionEfficiency = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .transmission-efficiency').val());
    if (transmissionEfficiency < 1 || transmissionEfficiency > 99) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .transmission-efficiency').val('96');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .transmission-efficiency').trigger('change');
    }
    let rollingResistance = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .rolling-resistance').val());
    if (rollingResistance < 0) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .rolling-resistance').val('0.0054');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .rolling-resistance').trigger('change');
    }
    let dragCoefficient = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .coefficient-of-drag').val());
    if (dragCoefficient < 0) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .coefficient-of-drag').val('0.24');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .coefficient-of-drag').trigger('change');
    }
    let angleOfSlope = parseFloat($('#motor-calculator-section.automotive-calculator .motor-calculation .angle-of-slope').val());
    if (angleOfSlope < -89 || angleOfSlope > 89) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .angle-of-slope').val('1');
      $('#motor-calculator-section.automotive-calculator .motor-calculation .angle-of-slope').trigger('change');
    }
    let gravity = 9.81;
    let effectiveMass = (mass * (1.04 + 0.0025 * gearRatio * gearRatio)).toFixed(1);
    let myData = JSON.parse(eval(`jsonMotorDataAutomotive${motorId}`));

    // Set Motor Data to Contact Form
    $('#motor-calculator-section.automotive-calculator #form-selected-motor').val(motorName);
    $('#motor-calculator-section.automotive-calculator #form-selected-car-frontal-area').val(frontalArea);
    $('#motor-calculator-section.automotive-calculator #form-selected-gear-ratio').val(gearRatio);
    $('#motor-calculator-section.automotive-calculator #form-selected-mass').val(mass);
    $('#motor-calculator-section.automotive-calculator #form-selected-tyre-radius').val(tyreRadius);

    // Calculation of Acceleration
    const gettorque = getTorqueForRPM(0, myData);
    const getThrust = gettorque * transmissionEfficiency * 0.01 * gearRatio / tyreRadius;
    const getResistanceForces = (0.5 * airDensity * frontalArea * dragCoefficient * 0) + (rollingResistance * effectiveMass * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMass * gravity * Math.sin(angleOfSlope * Math.PI / 180));
    const notChangingResistance = (rollingResistance * effectiveMass * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMass * gravity * Math.sin(angleOfSlope * Math.PI / 180));
    const getAcceleration = (getThrust - getResistanceForces) / (effectiveMass);

    let maxSpeedFromRPM = tyreRadius * 2 * 3.1416 * Number(myData[myData.length - 1][0]) / (60 * gearRatio);

    let previousVelocity = 0;
    let previousAcceleration = getAcceleration;
    let newVelocity = 0.02;
    let newAcceleration;
    let countTo100 = 0;
    let countToEnd = 0;

    let dontBreakLoop = true;

    while (dontBreakLoop) {
      countToEnd++;
      if (newVelocity < 27.7778) {
        countTo100++;
      }

      if (previousVelocity + previousAcceleration * 0.1 < maxSpeedFromRPM) {
        newVelocity = previousVelocity + previousAcceleration * 0.1;
      } else {
        dontBreakLoop = false;
      }
      newAcceleration = (((getTorqueForRPM((60 * newVelocity * gearRatio / (2 * 3.1416 * tyreRadius)), myData)) * transmissionEfficiency * 0.01 * gearRatio / tyreRadius) - (0.5 * airDensity * frontalArea * dragCoefficient * newVelocity * newVelocity + notChangingResistance)) / (effectiveMass);

      if (newAcceleration < 0.001 || countToEnd >= 3000 || newVelocity - previousVelocity < 0.001) {
        dontBreakLoop = false;
      }

      previousVelocity = newVelocity;
      previousAcceleration = newAcceleration;
    }

    if (newVelocity >= 27.778) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .vehicle-acceleration').text(`${((countTo100 - 1) / 10).toFixed(1)} sec`);
    } else {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .vehicle-acceleration').text('Cannot Reach 100km/h');
    }

    if (isNaN(newVelocity)) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .max-speed').text(`${parseInt(0)} mph`);
    } else if (maxSpeedFromRPM <= newVelocity) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .max-speed').text(`${parseInt(maxSpeedFromRPM * 2.236936)} mph`);
    } else if (maxSpeedFromRPM > newVelocity) {
      $('#motor-calculator-section.automotive-calculator .motor-calculation .max-speed').text(`${parseInt(newVelocity * 2.236936)} mph`);
    }
  }

  if ($('#motor-calculator-section.heavy-vehicle-calculator input[name="motor-select-heavy-vehicle"]:checked').val()) {
    // Get Selected Motor Details
    let motorRadio = $('#motor-calculator-section.heavy-vehicle-calculator input[name="motor-select-heavy-vehicle"]:checked').val();
    let motorValues = motorRadio.split('-');
    let motorId = parseFloat(motorValues[1]);
    let motorName = motorValues[2];

    $('#motor-calculator-section.heavy-vehicle-calculator #form-motor-name').text(motorName);

    // Get Input Values and Check for Validation
    let frontalArea = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .car-frontal-area').val());
    if (frontalArea < 0) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .car-frontal-area').val('2.24');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .car-frontal-area').trigger('change');
    }
    let mass = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .mass-of-car').val());
    if (mass <= 0) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .mass-of-car').val('1635');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .mass-of-car').trigger('change');
    }
    let gearRatio = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .gear-ratio').val());
    if (gearRatio < 1) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .gear-ratio').val('3');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .gear-ratio').trigger('change');
    }
    let tyreRadius = parseFloat($('.motor-calculation .tyre-radius').val());
    if (tyreRadius < 0) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .tyre-radius').val('0.2515');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .tyre-radius').trigger('change');
    }
    let airDensity = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .air-density').val());
    if (airDensity < 0 || airDensity > 1.5) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .air-density').val('1.225');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .air-density').trigger('change');
    }
    let transmissionEfficiency = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .transmission-efficiency').val());
    if (transmissionEfficiency < 1 || transmissionEfficiency > 99) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .transmission-efficiency').val('96');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .transmission-efficiency').trigger('change');
    }
    let rollingResistance = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .rolling-resistance').val());
    if (rollingResistance < 0) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .rolling-resistance').val('0.0054');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .rolling-resistance').trigger('change');
    }
    let dragCoefficient = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .coefficient-of-drag').val());
    if (dragCoefficient < 0) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .coefficient-of-drag').val('0.24');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .coefficient-of-drag').trigger('change');
    }
    let angleOfSlope = parseFloat($('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .angle-of-slope').val());
    if (angleOfSlope < -89 || angleOfSlope > 89) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .angle-of-slope').val('1');
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .angle-of-slope').trigger('change');
    }
    let gravity = 9.81;
    let effectiveMass = (mass * (1.04 + 0.0025 * gearRatio * gearRatio)).toFixed(1);
    let myData = JSON.parse(eval(`jsonMotorDataHeavyVehicle${motorId}`));

    // Set Motor Data to Contact Form
    $('#motor-calculator-section.heavy-vehicle-calculator #form-selected-motor').val(motorName);
    $('#motor-calculator-section.heavy-vehicle-calculator #form-selected-car-frontal-area').val(frontalArea);
    $('#motor-calculator-section.heavy-vehicle-calculator #form-selected-gear-ratio').val(gearRatio);
    $('#motor-calculator-section.heavy-vehicle-calculator #form-selected-mass').val(mass);
    $('#motor-calculator-section.heavy-vehicle-calculator #form-selected-tyre-radius').val(tyreRadius);

    // Calculation of Acceleration
    const gettorque = getTorqueForRPM(0, myData);
    const getThrust = gettorque * transmissionEfficiency * 0.01 * gearRatio / tyreRadius;
    const getResistanceForces = (0.5 * airDensity * frontalArea * dragCoefficient * 0) + (rollingResistance * effectiveMass * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMass * gravity * Math.sin(angleOfSlope * Math.PI / 180));
    const notChangingResistance = (rollingResistance * effectiveMass * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMass * gravity * Math.sin(angleOfSlope * Math.PI / 180));
    const getAcceleration = (getThrust - getResistanceForces) / (effectiveMass);

    let maxSpeedFromRPM = tyreRadius * 2 * 3.1416 * Number(myData[myData.length - 1][0]) / (60 * gearRatio);

    let previousVelocity = 0;
    let previousAcceleration = getAcceleration;
    let newVelocity = 0.02;
    let newAcceleration;
    let countTo100 = 0;
    let countToEnd = 0;

    let dontBreakLoop = true;

    while (dontBreakLoop) {
      countToEnd++;
      if (newVelocity < 27.7778) {
        countTo100++;
      }

      if (previousVelocity + previousAcceleration * 0.1 < maxSpeedFromRPM) {
        newVelocity = previousVelocity + previousAcceleration * 0.1;
      } else {
        dontBreakLoop = false;
      }
      newAcceleration = (((getTorqueForRPM((60 * newVelocity * gearRatio / (2 * 3.1416 * tyreRadius)), myData)) * transmissionEfficiency * 0.01 * gearRatio / tyreRadius) - (0.5 * airDensity * frontalArea * dragCoefficient * newVelocity * newVelocity + notChangingResistance)) / (effectiveMass);

      if (newAcceleration < 0.001 || countToEnd >= 3000 || newVelocity - previousVelocity < 0.001) {
        dontBreakLoop = false;
      }

      previousVelocity = newVelocity;
      previousAcceleration = newAcceleration;
    }

    if (newVelocity >= 27.778) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .vehicle-acceleration').text(`${((countTo100 - 1) / 10).toFixed(1)} sec`);
    } else {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .vehicle-acceleration').text('Cannot Reach 100km/h');
    }

    if (isNaN(newVelocity)) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .max-speed').text(`${parseInt(0)} mph`);
    } else if (maxSpeedFromRPM <= newVelocity) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .max-speed').text(`${parseInt(maxSpeedFromRPM * 2.236936)} mph`);
    } else if (maxSpeedFromRPM > newVelocity) {
      $('#motor-calculator-section.heavy-vehicle-calculator .motor-calculation .max-speed').text(`${parseInt(newVelocity * 2.236936)} mph`);
    }
  }
}

function motorListingCalculator(motorSectionWrp) {
  // Get Selected Motor Details
  let motorData = motorSectionWrp.attr('data-motor');
  let motorValues = motorData.split('-');
  let motorId = parseFloat(motorValues[1]);

  // Get Input Values and Check for Validation
  let frontalArea = parseFloat(motorSectionWrp.find('.car-frontal-area').val());
  if (frontalArea < 0) {
    motorSectionWrp.find('.car-frontal-area').val('2.24');
    motorSectionWrp.find('.car-frontal-area').trigger('change');
  }
  let mass = parseFloat(motorSectionWrp.find('.mass-of-car').val());
  if (mass <= 0) {
    motorSectionWrp.find('.mass-of-car').val('1635');
    motorSectionWrp.find('.mass-of-car').trigger('change');
  }
  let gearRatio = parseFloat(motorSectionWrp.find('.gear-ratio').val());
  if (gearRatio < 1) {
    motorSectionWrp.find('.gear-ratio').val('3');
    motorSectionWrp.find('.gear-ratio').trigger('change');
  }
  let tyreRadius = parseFloat(motorSectionWrp.find('.tyre-radius').val());
  if (tyreRadius < 0.0001) {
    motorSectionWrp.find('.tyre-radius').val('0.2515');
    motorSectionWrp.find('.tyre-radius').trigger('change');
  }

  let airDensity = parseFloat(motorSectionWrp.find('.air-density').val());
  if (airDensity < 0.4 || airDensity > 1.5) {
    motorSectionWrp.find('.air-density').val('1.225');
    motorSectionWrp.find('.air-density').trigger('change');
  }
  let transmissionEfficiency = parseFloat(motorSectionWrp.find('.transmission-efficiency').val());
  if (transmissionEfficiency < 1 || transmissionEfficiency > 99) {
    motorSectionWrp.find('.transmission-efficiency').val('96');
    motorSectionWrp.find('.transmission-efficiency').trigger('change');
  }
  let rollingResistance = parseFloat(motorSectionWrp.find('.rolling-resistance').val());
  if (rollingResistance < 0.0001) {
    motorSectionWrp.find('.rolling-resistance').val('0.0054');
    motorSectionWrp.find('.rolling-resistance').trigger('change');
  }
  let dragCoefficient = parseFloat(motorSectionWrp.find('.coefficient-of-drag').val());
  if (dragCoefficient < 0.01) {
    motorSectionWrp.find('.coefficient-of-drag').val('0.24');
    motorSectionWrp.find('.coefficient-of-drag').trigger('change');
  }
  let angleOfSlope = parseFloat(motorSectionWrp.find('.angle-of-slope').val());
  if (angleOfSlope < -89 || angleOfSlope > 89) {
    motorSectionWrp.find('.angle-of-slope').val('1');
    motorSectionWrp.find('.angle-of-slope').trigger('change');
  }

  let gravity = 9.81;
  let effectiveMassListing = (mass * (1.04 + 0.0025 * gearRatio * gearRatio)).toFixed(1);
  let myDataListing = JSON.parse(eval(`jsonMotorDataListing${motorId}`));

  // Calculation of Acceleration
  const gettorque = getTorqueForRPM(0, myDataListing);
  const getThrust = gettorque * transmissionEfficiency * 0.01 * gearRatio / tyreRadius;
  const getResistanceForces = (0.5 * airDensity * frontalArea * dragCoefficient * 0) + (rollingResistance * effectiveMassListing * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMassListing * gravity * Math.sin(angleOfSlope * Math.PI / 180));
  const notChangingResistance = (rollingResistance * effectiveMassListing * gravity * Math.cos(angleOfSlope * Math.PI / 180)) + (effectiveMassListing * gravity * Math.sin(angleOfSlope * Math.PI / 180));
  const getAcceleration = (getThrust - getResistanceForces) / (effectiveMassListing);

  let maxSpeedFromRPM = tyreRadius * 2 * 3.1416 * Number(myDataListing[myDataListing.length - 1][0]) / (60 * gearRatio);

  let previousVelocity = 0;
  let previousAcceleration = getAcceleration;
  let newVelocity = 0.02;
  let newAcceleration;
  let countTo100 = 0;
  let countToEnd = 0;

  let dontBreakLoop = true;

  while (dontBreakLoop) {
    countToEnd++;
    if (newVelocity < 27.7778) {
      countTo100++;
    }

    if (previousVelocity + previousAcceleration * 0.1 < maxSpeedFromRPM) {
      newVelocity = previousVelocity + previousAcceleration * 0.1;
    } else {
      dontBreakLoop = false;
    }
    newAcceleration = (((getTorqueForRPM((60 * newVelocity * gearRatio / (2 * 3.1416 * tyreRadius)), myDataListing)) * transmissionEfficiency * 0.01 * gearRatio / tyreRadius) - (0.5 * airDensity * frontalArea * dragCoefficient * newVelocity * newVelocity + notChangingResistance)) / (effectiveMassListing);

    if (newAcceleration < 0.001 || countToEnd >= 3000 || newVelocity - previousVelocity < 0.001) {
      dontBreakLoop = false;
    }

    previousVelocity = newVelocity;
    previousAcceleration = newAcceleration;
  }

  if (newVelocity >= 27.778) {
    motorSectionWrp.find('.vehicle-acceleration').text(`${((countTo100 - 1) / 10).toFixed(1)} sec`);
  } else {
    motorSectionWrp.find('.vehicle-acceleration').text('Cannot Reach 100km/h');
  }

  if (isNaN(newVelocity)) {
    motorSectionWrp.find('.max-speed').text(`${parseInt(0)} mph`);
  } else if (maxSpeedFromRPM <= newVelocity) {
    motorSectionWrp.find('.max-speed').text(`${parseInt(maxSpeedFromRPM * 2.236936)} mph`);
  } else if (maxSpeedFromRPM > newVelocity) {
    motorSectionWrp.find('.max-speed').text(`${parseInt(newVelocity * 2.236936)} mph`);
  }
}

function checkSectionsForGaps() {
  $('.fcp-section.bg-enabled, .fcp-section.with-image, .fcp-section.image-section.v1, .fcp-section.video-section.v1, .fcp-section.cta-section').each(function () {
    if ($(this).next().hasClass('bg-enabled')) {
      $(this).addClass('bg-next');
    }
  });

  $('.fcp-section.bg-enabled, .fcp-section.with-image, .fcp-section.image-section.v1, .fcp-section.video-section.v1').each(function () {
    if ($(this).next().hasClass('cta-section')) {
      $(this).addClass('cta-next');
    }
  });
}

function getTorqueForRPM(rpm, jsonMotorData) {
  let roundRPM = Math.round(rpm / 100) * 100;
  for (let i = 0; i < jsonMotorData.length; i++) {
    if (Number(jsonMotorData[i][0]) == roundRPM) {
      return Number(jsonMotorData[i][1])
    }
  }
}

function checkMapWidth() {
  let addressWrapperWidth = $('#map-address-wrp').width();
  let mapWrapperWidth = $('.map-wrp').width();

  if (mapWrapperWidth < addressWrapperWidth) {
    return true;
  } else {
    return false;
  }
}

// Cookie Policy Popup
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
// Cookie Policy Popup

// New Calculator
function newCalculator() {
  // Calculations on Initial Load
  let selectedCalculation = $('#new-motor-calculator .select-calculation').val();
  $('#new-motor-calculator .calculator-body-wrp .calculator-item').each(function () {
    $(this).slideUp();
  });
  $(`#new-motor-calculator .calculator-body-wrp .calculator-item.${selectedCalculation}`).slideDown();
  // Calculations on Initial Load

  // Calculations on Change
  $('#new-motor-calculator .select-calculation').on('change', function () {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item').each(function () {
      $(this).slideUp();
    });
    $(`#new-motor-calculator .calculator-body-wrp .calculator-item.${this.value}`).slideDown();
  });

  $('#reset-button-hydraulic-calculator').click(function (e) {
    e.preventDefault();
    $('.calculator-item input').each(function () {
      $(this).val('');
      $(this).prop('disabled', false);
    });

    $('#new-motor-calculator .calculator-item .calculator-row .final-answer').each(function () {
      $(this).text('');
    });

  });

  $('#new-motor-calculator select.calculator-units-change').on('change', function () {
    speedCalculator();
    flowRateCalculator();
    pressureCalculator();
    displacementCalculator();
    torqueCalculator();
    powerCalculator();
  });

  $('#new-motor-calculator .calculator-units-change.metric').parent().removeClass('d-none');

  $('#new-motor-calculator  input[type=radio][name=base-units-change-radio]').change(function () {
    if (this.value == 'metric') {
      $('#new-motor-calculator .calculator-units-change.metric').each(function () {
        $(this).removeClass('d-none');
        $(this).parent().removeClass('d-none');
        $(this).parent().siblings('.select2-calculator-wrapper').children('select.imperial').addClass('d-none');
        $(this).parent().siblings('.select2-calculator-wrapper').addClass('d-none');
        // $(this).siblings('.imperial').parent().siblings().addClass('d-none');
      });
    }
    else if (this.value == 'imperial') {
      $('#new-motor-calculator .calculator-units-change.imperial').each(function () {
        $(this).removeClass('d-none');
        $(this).parent().removeClass('d-none');
        $(this).parent().siblings('.select2-calculator-wrapper').children('select.metric').addClass('d-none');
        $(this).parent().siblings('.select2-calculator-wrapper').addClass('d-none');
        // $(this).siblings('.metric').parent().siblings().addClass('d-none');
      });
    }

    flowRateCalculator();
    speedCalculator();
    pressureCalculator();
    displacementCalculator();
    torqueCalculator();
    powerCalculator();
  });

  speedCalculator();
  flowRateCalculator();
  pressureCalculator();
  displacementCalculator();
  torqueCalculator();
  powerCalculator();
  // Calculations on Change
}

function speedCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').parent().parent().addClass('disabled-field');

      speedCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').parent().parent().addClass('disabled-field');

      speedCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val()) {
    speedCalc1();
  }
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val()) {
    speedCalc2();
  }
}

function speedCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val()) {
    let torqueValue;
    if ($('#new-motor-calculator .speed-calculator-torque-units:not(.d-none) option:selected').val() == 'newtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val();
    } else if ($('#new-motor-calculator .speed-calculator-torque-units:not(.d-none) option:selected').val() == 'knewtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val() * 1000;
    } else if ($('#new-motor-calculator .speed-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfin') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val() / 8.850745454;
    } else if ($('#new-motor-calculator .speed-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfft') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#torque').val() / 0.7375621212;
    }
    let powerValue;
    if ($('#new-motor-calculator .speed-calculator-power-units:not(.d-none) option:selected').val() == 'watt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val();
    } else if ($('#new-motor-calculator .speed-calculator-power-units:not(.d-none) option:selected').val() == 'kwatt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val() * 1000;
    } else if ($('#new-motor-calculator .speed-calculator-power-units:not(.d-none) option:selected').val() == 'hp') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val() * 745.7;
    }

    let answer;
    if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rps') {
      answer = (powerValue / torqueValue) / (2 * Math.PI);
    } else if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rads') {
      answer = (powerValue * 6.2832 / torqueValue) / (2 * Math.PI);
    } else if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rpm') {
      answer = (powerValue * 60 / torqueValue) / (2 * Math.PI);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator #answer-speed').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator #answer-speed').text('');
  }
}

function speedCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val()) {
    let flowRate;
    if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmps') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val();
    } else if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmpmin') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() / 60;
    } else if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'lpm') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() / 60000;
    } else if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'gpm') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() / 15850.3;
    } else if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfm') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() / 2118.88;
    } else if ($('#new-motor-calculator .speed-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfs') {
      flowRate = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#flow-rate').val() / 35.315;
    }
    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#volumetric-efficiency').val();
    let displacement;
    if ($('#new-motor-calculator .speed-calculator-displacement-units:not(.d-none) option:selected').val() == 'cmprev') {
      displacement = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val();
    } else if ($('#new-motor-calculator .speed-calculator-displacement-units:not(.d-none) option:selected').val() == 'ccmprev') {
      displacement = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val() / 1000000;
    } else if ($('#new-motor-calculator .speed-calculator-displacement-units:not(.d-none) option:selected').val() == 'cinprev') {
      displacement = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val() / 61023.7;
    } else if ($('#new-motor-calculator .speed-calculator-displacement-units:not(.d-none) option:selected').val() == 'cftprev') {
      displacement = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#displacement').val() / 35.3147;
    }
    let answer;
    if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rps') {
      answer = (flowRate * volumetricEfficiency / 100) / displacement;
    } else if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rads') {
      answer = (flowRate * volumetricEfficiency * 6.2831 / 100) / displacement;
    } else if ($('#new-motor-calculator .speed-calculator-answer-units:not(.d-none) option:selected').val() == 'rpm') {
      answer = (flowRate * volumetricEfficiency * 60 / 100) / displacement;
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator #answer-speed').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator #answer-speed').text('');
  }
}

function flowRateCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').parent().parent().addClass('disabled-field');

      flowRateCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').parent().parent().addClass('disabled-field');

      flowRateCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val()) {
    flowRateCalc1();
  }
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val()) {
    flowRateCalc2();
  }
}

function flowRateCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val()) {
    let displacementValue;
    if ($('#new-motor-calculator .flowrate-calculator-displacement-units:not(.d-none) option:selected').val() == 'cmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val();
    } else if ($('#new-motor-calculator .flowrate-calculator-displacement-units:not(.d-none) option:selected').val() == 'ccmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() / 1000000;
    } else if ($('#new-motor-calculator .flowrate-calculator-displacement-units:not(.d-none) option:selected').val() == 'cinprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() / 61023.7;
    } else if ($('#new-motor-calculator .flowrate-calculator-displacement-units:not(.d-none) option:selected').val() == 'cftprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#displacement').val() / 35.3147;
    }

    let speedValue;
    if ($('#new-motor-calculator .flowrate-calculator-speed-units:not(.d-none) option:selected').val() == 'rps') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val();
    } else if ($('#new-motor-calculator .flowrate-calculator-speed-units:not(.d-none) option:selected').val() == 'rads') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val() / 6.2832;
    } else if ($('#new-motor-calculator .flowrate-calculator-speed-units:not(.d-none) option:selected').val() == 'rpm') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#speed').val() / 60;
    }

    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val();

    let answer;
    if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cmps') {
      answer = displacementValue * speedValue * 100 / volumetricEfficiency;
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cmpmin') {
      answer = displacementValue * speedValue * 100 * 60 / volumetricEfficiency;
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'lpm') {
      answer = displacementValue * speedValue * 100 * 60 * 1000 / volumetricEfficiency;
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'gpm') {
      answer = displacementValue * speedValue * 100 * 15850.3 / volumetricEfficiency;
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cfm') {
      answer = displacementValue * speedValue * 100 * 2118.88 / volumetricEfficiency;
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cfs') {
      answer = displacementValue * speedValue * 100 * 35.315 / volumetricEfficiency;
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator #answer-flowrate').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator #answer-flowrate').text('');
  }
}

function flowRateCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val()) {

    let powerValue;
    if ($('#new-motor-calculator .flowrate-calculator-power-units:not(.d-none) option:selected').val() == 'watt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val();
    } else if ($('#new-motor-calculator .flowrate-calculator-power-units:not(.d-none) option:selected').val() == 'kwatt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val() * 1000;
    } else if ($('#new-motor-calculator .flowrate-calculator-power-units:not(.d-none) option:selected').val() == 'hp') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#power').val() * 745.7;
    }

    let pressureValue;
    if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'pascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val();
    } else if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'kpascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() * 1000;
    } else if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'bar') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() * 100000;
    } else if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'psi') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() * 6894.76;
    } else if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() * 47.88;
    } else if ($('#new-motor-calculator .flowrate-calculator-pressure-units:not(.d-none) option:selected').val() == 'atm') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#pressure').val() * 101325;
    }

    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#volumetric-efficiency').val();
    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator input#mechanical-efficiency').val();

    let answer;
    if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cmps') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cmpmin') {
      answer = powerValue * 10000 * 60 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'lpm') {
      answer = powerValue * 10000 * 60 * 1000 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'gpm') {
      answer = powerValue * 10000 * 15850.3 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cfm') {
      answer = powerValue * 10000 * 2118.88 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .flowrate-calculator-answer-units:not(.d-none) option:selected').val() == 'cfs') {
      answer = powerValue * 10000 * 35.315 / (volumetricEfficiency * mechanicalEfficiency * pressureValue);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator #answer-flowrate').text(answer.toFixed(3));

  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.flowrate-calculator #answer-flowrate').text('');
  }
}

function pressureCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').parent().parent().addClass('disabled-field');

      pressureCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').parent().parent().addClass('disabled-field');

      pressureCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val()) {
    pressureCalc1();
  }
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val()) {
    pressureCalc2();
  }
}

function pressureCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val()) {
    let powerValue;
    if ($('#new-motor-calculator .pressure-calculator-power-units:not(.d-none) option:selected').val() == 'watt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val();
    } else if ($('#new-motor-calculator .pressure-calculator-power-units:not(.d-none) option:selected').val() == 'kwatt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val() * 1000;
    } else if ($('#new-motor-calculator .pressure-calculator-power-units:not(.d-none) option:selected').val() == 'hp') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#power').val() * 745.7;
    }

    let flowRateValue;
    if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmps') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val();
    } else if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmpmin') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() / 60;
    } else if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'lpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() / 60000;
    } else if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'gpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() / 15850.3;
    } else if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() / 2118.88;
    } else if ($('#new-motor-calculator .pressure-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfs') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#flowrate').val() / 35.315;
    }

    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#volumetric-efficiency').val();
    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val();

    let answer;
    if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'pascal') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'kpascal') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue * 1000);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'bar') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue * 100000);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'psi') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue * 6894.76);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue * 47.88);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'atm') {
      answer = powerValue * 10000 / (volumetricEfficiency * mechanicalEfficiency * flowRateValue);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator #answer-pressure').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator #answer-pressure').text('');
  }
}

function pressureCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val()) {
    let torqueValue;
    if ($('#new-motor-calculator .pressure-calculator-torque-units:not(.d-none) option:selected').val() == 'newtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val();
    } else if ($('#new-motor-calculator .pressure-calculator-torque-units:not(.d-none) option:selected').val() == 'knewtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() * 1000;
    } else if ($('#new-motor-calculator .pressure-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfin') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() / 8.850745454;
    } else if ($('#new-motor-calculator .pressure-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfft') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#torque').val() / 0.7375621212;
    }

    let displacementValue;
    if ($('#new-motor-calculator .pressure-calculator-displacement-units:not(.d-none) option:selected').val() == 'cmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val();
    } else if ($('#new-motor-calculator .pressure-calculator-displacement-units:not(.d-none) option:selected').val() == 'ccmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val() / 1000000;
    } else if ($('#new-motor-calculator .pressure-calculator-displacement-units:not(.d-none) option:selected').val() == 'cinprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val() / 61023.7;
    } else if ($('#new-motor-calculator .pressure-calculator-displacement-units:not(.d-none) option:selected').val() == 'cftprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#displacement').val() / 35.3147;
    }

    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator input#mechanical-efficiency').val();

    let answer;
    if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'pascal') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'kpascal') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue * 1000);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'bar') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue * 100000);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'psi') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue * 6894.76);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue * 47.88);
    } else if ($('#new-motor-calculator .pressure-calculator-answer-units:not(.d-none) option:selected').val() == 'atm') {
      answer = torqueValue * 2 * Math.PI * 100 / (mechanicalEfficiency * displacementValue * 101325);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator #answer-pressure').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.pressure-calculator #answer-pressure').text('');
  }
}

function displacementCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').parent().parent().addClass('disabled-field');

      displacementCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').parent().parent().addClass('disabled-field');

      displacementCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val()) {
    displacementCalc1();
  }

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val()) {
    displacementCalc2();
  }
}

function displacementCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val()) {
    let torqueValue;
    if ($('#new-motor-calculator .displacement-calculator-torque-units:not(.d-none) option:selected').val() == 'newtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val();
    } else if ($('#new-motor-calculator .displacement-calculator-torque-units:not(.d-none) option:selected').val() == 'knewtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() * 1000;
    } else if ($('#new-motor-calculator .displacement-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfin') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() / 8.850745454;
    } else if ($('#new-motor-calculator .displacement-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfft') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#torque').val() / 0.7375621212;
    }

    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#mechanical-efficiency').val();

    let pressureValue;
    if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'pascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val();
    } else if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'kpascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val() * 1000;
    } else if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'bar') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val() * 100000;
    } else if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'psi') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val() * 6894.76;
    } else if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val() * 47.88;
    } else if ($('#new-motor-calculator .displacement-calculator-pressure-units:not(.d-none) option:selected').val() == 'atm') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#pressure').val() * 101325;
    }

    let answer;
    if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cmprev') {
      answer = torqueValue * Math.PI * 200 / (mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'ccmprev') {
      answer = torqueValue * Math.PI * 200 * 1000000 / (mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cinprev') {
      answer = torqueValue * Math.PI * 200 * 61023.7 / (mechanicalEfficiency * pressureValue);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cftprev') {
      answer = torqueValue * Math.PI * 200 * 35.3147 / (mechanicalEfficiency * pressureValue);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator #answer-displacement').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator #answer-displacement').text('');
  }
}

function displacementCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val()) {
    let flowRateValue;
    if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmps') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val();
    } else if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmpmin') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() / 60;
    } else if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'lpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() / 60000;
    } else if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'gpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() / 15850.3;
    } else if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() / 2118.88;
    } else if ($('#new-motor-calculator .displacement-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfs') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#flowrate').val() / 35.315;
    }

    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#volumetric-efficiency').val();

    let speedValue;
    if ($('#new-motor-calculator .displacement-calculator-speed-units:not(.d-none) option:selected').val() == 'rps') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val();
    } else if ($('#new-motor-calculator .displacement-calculator-speed-units:not(.d-none) option:selected').val() == 'rads') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val() / 6.2832;
    } else if ($('#new-motor-calculator .displacement-calculator-speed-units:not(.d-none) option:selected').val() == 'rpm') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator input#speed').val() / 60;
    }

    let answer;
    if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cmprev') {
      answer = flowRateValue * volumetricEfficiency / (speedValue * 100);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'ccmprev') {
      answer = flowRateValue * volumetricEfficiency * 1000000 / (speedValue * 100);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cinprev') {
      answer = flowRateValue * volumetricEfficiency * 61023.7 / (speedValue * 100);
    } else if ($('#new-motor-calculator .displacement-calculator-answer-units:not(.d-none) option:selected').val() == 'cftprev') {
      answer = flowRateValue * volumetricEfficiency * 35.3147 / (speedValue * 100);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator #answer-displacement').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.displacement-calculator #answer-displacement').text('');
  }
}

function torqueCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').parent().parent().addClass('disabled-field');

      torqueCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').parent().parent().addClass('disabled-field');

      torqueCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val()) {
    torqueCalc1();
  }
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val()) {
    torqueCalc2();
  }
}

function torqueCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val()) {

    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#mechanical-efficiency').val();

    let displacementValue;
    if ($('#new-motor-calculator .torque-calculator-displacement-units:not(.d-none) option:selected').val() == 'cmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val();
    } else if ($('#new-motor-calculator .torque-calculator-displacement-units:not(.d-none) option:selected').val() == 'ccmprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() / 1000000;
    } else if ($('#new-motor-calculator .torque-calculator-displacement-units:not(.d-none) option:selected').val() == 'cinprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() / 61023.7;
    } else if ($('#new-motor-calculator .torque-calculator-displacement-units:not(.d-none) option:selected').val() == 'cftprev') {
      displacementValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#displacement').val() / 35.3147;
    }

    let pressureValue;
    if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'pascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val();
    } else if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'kpascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val() * 1000;
    } else if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'bar') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val() * 100000;
    } else if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'psi') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val() * 6894.76;
    } else if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val() * 47.88;
    } else if ($('#new-motor-calculator .torque-calculator-pressure-units:not(.d-none) option:selected').val() == 'atm') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#pressure').val() * 101325;
    }

    let answer;
    if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'newtnm') {
      answer = mechanicalEfficiency * pressureValue * displacementValue / (200 * Math.PI);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'knewtnm') {
      answer = mechanicalEfficiency * pressureValue * displacementValue / (200 * Math.PI * 1000);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'lbfin') {
      answer = mechanicalEfficiency * pressureValue * displacementValue * 8.850745454 / (200 * Math.PI);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'lbfft') {
      answer = mechanicalEfficiency * pressureValue * displacementValue * 0.7375621212 / (200 * Math.PI);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator #answer-torque').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator #answer-torque').text('');
  }
}

function torqueCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val()) {
    let powerValue;
    if ($('#new-motor-calculator .torque-calculator-power-units:not(.d-none) option:selected').val() == 'watt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val();
    } else if ($('#new-motor-calculator .torque-calculator-power-units:not(.d-none) option:selected').val() == 'kwatt') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val() * 1000;
    } else if ($('#new-motor-calculator .torque-calculator-power-units:not(.d-none) option:selected').val() == 'hp') {
      powerValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#power').val() * 745.7;
    }

    let speedValue;
    if ($('#new-motor-calculator .torque-calculator-speed-units:not(.d-none) option:selected').val() == 'rps') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val() * 2 * Math.PI;
    } else if ($('#new-motor-calculator .torque-calculator-speed-units:not(.d-none) option:selected').val() == 'rads') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val();
    } else if ($('#new-motor-calculator .torque-calculator-speed-units:not(.d-none) option:selected').val() == 'rpm') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator input#speed').val() * 2 * Math.PI / (60);
    }

    let answer;
    if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'newtnm') {
      answer = powerValue / (speedValue);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'knewtnm') {
      answer = powerValue / (speedValue * 1000);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'lbfin') {
      answer = powerValue * 8.850745454 / (speedValue);
    } else if ($('#new-motor-calculator .torque-calculator-answer-units:not(.d-none) option:selected').val() == 'lbfft') {
      answer = powerValue * 0.7375621212 / (speedValue);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator #answer-torque').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.torque-calculator #answer-torque').text('');
  }
}

function powerCalculator() {
  $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input').on('input', function () {
    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').parent().parent().addClass('disabled-field');

      powerCalc1();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').parent().parent().removeClass('disabled-field');
    }

    if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flow-rate').val() || $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val()) {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').parent().parent().addClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').prop('disabled', true);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').parent().parent().addClass('disabled-field');

      powerCalc2();

    } else {
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').parent().parent().removeClass('disabled-field');
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').prop('disabled', false);
      $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').parent().parent().removeClass('disabled-field');
    }
  });

  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val()) {
    powerCalc1();
  }
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val()) {
    powerCalc2();
  }
}

function powerCalc1() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val()) {
    let torqueValue;
    if ($('#new-motor-calculator .power-calculator-torque-units:not(.d-none) option:selected').val() == 'newtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val();
    } else if ($('#new-motor-calculator .power-calculator-torque-units:not(.d-none) option:selected').val() == 'knewtnm') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() * 1000;
    } else if ($('#new-motor-calculator .power-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfin') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() / 8.850745454;
    } else if ($('#new-motor-calculator .power-calculator-torque-units:not(.d-none) option:selected').val() == 'lbfft') {
      torqueValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#torque').val() / 0.7375621212;
    }

    let speedValue;
    if ($('#new-motor-calculator .power-calculator-speed-units:not(.d-none) option:selected').val() == 'rps') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val() * 2 * Math.PI;
    } else if ($('#new-motor-calculator .power-calculator-speed-units:not(.d-none) option:selected').val() == 'rads') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val();
    } else if ($('#new-motor-calculator .power-calculator-speed-units:not(.d-none) option:selected').val() == 'rpm') {
      speedValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#speed').val() * 2 * Math.PI / (60);
    }

    let answer;
    if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'watt') {
      answer = torqueValue * speedValue;
    } else if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'kwatt') {
      answer = torqueValue * speedValue / 1000;
    } else if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'hp') {
      answer = torqueValue * speedValue / 745.7;
    }
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator #answer-power').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator #answer-power').text('');
  }
}

function powerCalc2() {
  if ($('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() && $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val()) {
    let flowRateValue;
    if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmps') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val();
    } else if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cmpmin') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() / 60;
    } else if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'lpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() / 60000;
    } else if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'gpm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() / 15850.3;
    } else if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfm') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() / 2118.88;
    } else if ($('#new-motor-calculator .power-calculator-flowrate-units:not(.d-none) option:selected').val() == 'cfs') {
      flowRateValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#flowrate').val() / 35.315;
    }

    let pressureValue;
    if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'pascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val();
    } else if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'kpascal') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val() * 1000;
    } else if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'bar') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val() * 100000;
    } else if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'psi') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val() * 6894.76;
    } else if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'lbftsqr') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val() * 47.88;
    } else if ($('#new-motor-calculator .power-calculator-pressure-units:not(.d-none) option:selected').val() == 'atm') {
      pressureValue = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#pressure').val() * 101325;
    }

    let volumetricEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#volumetric-efficiency').val();
    let mechanicalEfficiency = $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator input#mechanical-efficiency').val();

    let answer;
    if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'watt') {
      // answer = $('#new-motor-calculator .calculator-body-wrp .calculator-item.speed-calculator input#power').val();
      answer = flowRateValue * pressureValue * volumetricEfficiency * mechanicalEfficiency / 10000;
    } else if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'kwatt') {
      answer = flowRateValue * pressureValue * volumetricEfficiency * mechanicalEfficiency / (1000 * 10000);
    } else if ($('#new-motor-calculator .power-calculator-answer-units:not(.d-none) option:selected').val() == 'hp') {
      answer = flowRateValue * pressureValue * volumetricEfficiency * mechanicalEfficiency / (745.7 * 10000);
    }

    $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator #answer-power').text(answer.toFixed(3));
  } else {
    $('#new-motor-calculator .calculator-body-wrp .calculator-item.power-calculator #answer-power').text('');
  }
}
// New Calculator

// custom mtor design form
function customMotorForm() {
  $('.accordion-form-section').each(function () {
    $(this).find('.accordion-item-wrp').each(function () {
      $(this).find('.go-to-next-section').each(function () {
        $(this).click(function () {
          $(this).parents('.accordion-item-wrp').next().find('.faq-title').trigger('click');
          $('html, body').animate({
            scrollTop: $(this).parents('.accordion-item-wrp').offset().top,
          }, 'smooth');
        });
      });

      $(this).find('.go-to-submit').each(function () {
        $(this).click(function () {
          $(this).parents('.accordion-item-wrp').siblings('.accordion-item-wrp').find('.wpcf7-submit').trigger('click');
        });
      });
    });
    $(this).find('.screen-reader-response').appendTo($(this).find('.accordion-item-wrp.first .faq-title'));

    $(this).find('.submit-button-container').find('.wpcf7-submit').click(function () {
      $(this).parents('.accordion-form-section').find('.intro-content').addClass('submit-message');
      $('html, body').animate({
        scrollTop: $('.accordion-form-section').offset().top,
      }, 'smooth');
    });
  });
}
// custom mtor design form

// Function to scroll to a section based on the hash in the URL
function scrollToSection() {
  const hash = window.location.hash;
  if (hash) {

    const targetId = hash.substring(1);
    const $targetSection = $('#' + targetId);

    if ($targetSection.length) {
      $('html, body').animate({
        scrollTop: $targetSection.offset().top,
      }, 'smooth');
    }
  }
}
// Function to scroll to a section based on the hash in the URL

// Marine Calculator
function marineCalculator() {
  if ($('.marine-calculator')) {
    //On Change
    $('#marine-calculator input').on('keyup change', function () {
      runMarineCalculation();
    });
    //On Change
  }
}

function runMarineCalculation() {
  let yachtLength = $('#marine-calculator input#yacht-length').val();
  if (yachtLength < 0) {
    $('#marine-calculator input#yacht-length').val('15');
    setTimeout(function () {
      $('#marine-calculator input#yacht-length').trigger('change');
    }, 100);
  }
  let beam = $('#marine-calculator input#beam').val();
  if (beam < 0) {
    $('#marine-calculator input#beam').val('4');
    setTimeout(function () {
      $('#marine-calculator input#beam').trigger('change');
    }, 100);
  }
  // let draft = $('#marine-calculator input#draft').val();
  let displacement = $('#marine-calculator input#displacement').val();
  if (displacement < 0) {
    $('#marine-calculator input#displacement').val('21000');
    setTimeout(function () {
      $('#marine-calculator input#displacement').trigger('change');
    }, 100);
  }
  let desiredSpeed = $('#marine-calculator input#desired-speed').val();
  if (desiredSpeed < 0) {
    $('#marine-calculator input#desired-speed').val('8');
    setTimeout(function () {
      $('#marine-calculator input#desired-speed').trigger('change');
    }, 100);
  }
  let propEfficiency = $('#marine-calculator input#prop-efficiency').val();
  if (propEfficiency < 0 || propEfficiency > 100) {
    $('#marine-calculator input#prop-efficiency').val('60');
    setTimeout(function () {
      $('#marine-calculator input#prop-efficiency').trigger('change');
    }, 100);
  }
  let shaftLoss = $('#marine-calculator input#shaft-loss').val();
  if (shaftLoss < 0 || shaftLoss > 100) {
    $('#marine-calculator input#shaft-loss').val('90');
    setTimeout(function () {
      $('#marine-calculator input#shaft-loss').trigger('change');
    }, 100);
  }
  let electricalEfficiency = $('#marine-calculator input#electrical-efficiency').val();
  if (electricalEfficiency < 0 || electricalEfficiency > 100) {
    $('#marine-calculator input#electrical-efficiency').val('100');
    setTimeout(function () {
      $('#marine-calculator input#electrical-efficiency').trigger('change');
    }, 100);
  }
  let gearboxEfficiency = $('#marine-calculator input#gearbox-efficiency').val();
  if (gearboxEfficiency < 0 || gearboxEfficiency > 100) {
    $('#marine-calculator input#gearbox-efficiency').val('97');
    setTimeout(function () {
      $('#marine-calculator input#gearbox-efficiency').trigger('change');
    }, 100);
  }
  let propPitch = $('#marine-calculator input#prop-pitch').val();
  if (propPitch < 0) {
    $('#marine-calculator input#prop-pitch').val('12');
    setTimeout(function () {
      $('#marine-calculator input#prop-pitch').trigger('change');
    }, 100);
  }
  let gearRatio = $('#marine-calculator input#gear-ratio').val();
  if (gearRatio < 0) {
    $('#marine-calculator input#gear-ratio').val('1');
    setTimeout(function () {
      $('#marine-calculator input#gear-ratio').trigger('change');
    }, 100);
  }
  let propSlip = $('#marine-calculator input#prop-slip').val();
  if (propSlip < 0 || propSlip > 100) {
    $('#marine-calculator input#prop-slip').val('10');
    setTimeout(function () {
      $('#marine-calculator input#prop-slip').trigger('change');
    }, 100);
  }

  // Principal Particulars
  let C2 = yachtLength * 0.95;
  let C3 = yachtLength;
  let C4 = beam;
  // let C5 = 1.5; // Can be a Input (Moulded)
  let C5 = $('#marine-calculator .modal input#moulded').val();
  if (C5 < 0) {
    $('#marine-calculator .modal input#moulded').val('1.5');
    setTimeout(function () {
      $('#marine-calculator .modal input#moulded').trigger('change');
    }, 100);
  }
  let C6 = C5;
  let C7 = displacement / 1000;
  // let C8 = 1025; // Can be a Input (Density of sea water)
  let C8 = $('#marine-calculator .modal input#density-sea-water').val();
  if (C8 < 0 || C8 > 1050) {
    $('#marine-calculator .modal input#density-sea-water').val('1025');
    setTimeout(function () {
      $('#marine-calculator .modal input#density-sea-water').trigger('change');
    }, 100);
  }
  let C9 = 1.1584133 * (10 ** (-6));
  let C10 = C7;
  // let C11 = 0; // Can be a Input (Trim)
  let C12 = desiredSpeed;
  let C13 = 9.81;
  let C14 = C12 * 0.5144 / (Math.sqrt(C13 * C2));
  // Principal Particulars
  let C71 = C2 / C4;

  // Froude number ≤ 0.4
  let C17 = C12 * 0.5144 * C2 / C9;
  let C18 = 0.075 / ((Math.log10(C17)) - 2) ** 2;
  // let C19 = 0.1;
  let C19 = $('#marine-calculator .modal input#c-stern').val();
  if (C19 < 0) {
    $('#marine-calculator .modal input#c-stern').val('0.1');
    setTimeout(function () {
      $('#marine-calculator .modal input#c-stern').trigger('change');
    }, 100);
  }
  // let C20 = 1+0.011*C19;
  // let C21 = 8;
  // let C22 = 0.984;
  // let C23 = 0.837;
  // let C24 = 0.85;
  let C22 = $('#marine-calculator .modal input#midship-coeff').val();
  if (C22 < 0 || C22 > 1) {
    $('#marine-calculator .modal input#midship-coeff').val('0.984');
    setTimeout(function () {
      $('#marine-calculator .modal input#midship-coeff').trigger('change');
    }, 100);
  }
  let C23 = $('#marine-calculator .modal input#block-coeff').val();
  if (C23 < 0 || C23 > 1) {
    $('#marine-calculator .modal input#block-coeff').val('0.837');
    setTimeout(function () {
      $('#marine-calculator .modal input#block-coeff').trigger('change');
    }, 100);
  }
  let C24 = $('#marine-calculator .modal input#prismatic-coeff').val();
  if (C24 < 0 || C24 > 1) {
    $('#marine-calculator .modal input#prismatic-coeff').val('0.850');
    setTimeout(function () {
      $('#marine-calculator .modal input#prismatic-coeff').trigger('change');
    }, 100);
  }
  // Froude number ≤ 0.4

  // Form factor and Appendages
  let C27 = (C2 / 10) * 4;
  let C28 = (C27 - (C3 / 2)) * 100 / C3;
  let C29 = C2 * (1 - C24 + (0.06 * C24 * C28) / (4 * C24 - 1)) * (-1);
  let C30 = C2 * C4 * C24;
  let C31 = C30 * 0.1;
  let C32 = C30 + C31;
  let C33 = 0.93 + (0.4871 * C19 * ((C4 / C2) ** 1.0681)) * ((C6 / C2) ** 0.4611) * ((C2 / C29) ** 0.1216) * (((C2 ** 3) / C7) ** 0.3649) * ((1 - C24) ** (-0.6042));
  // let C34 = 2.1;
  let C34 = $('#marine-calculator .modal input#appendages-form-factor').val();
  if (C34 < 0) {
    $('#marine-calculator .modal input#appendages-form-factor').val('2.1');
    setTimeout(function () {
      $('#marine-calculator .modal input#appendages-form-factor').trigger('change');
    }, 100);
  }
  let C35 = C33 + ((C34 - C33) * C31 / C32);
  // let C36 = 0.001*(0.5*C8*((C12*0.5144)**2)*C18*C32*C35);
  // let C37 = 0; // Can be a Input (mast area)
  // Form factor and Appendages


  // Wave-making Resistance Calculations
  let C61 = C4 / C2;
  let C62;
  if (C61 <= 0.11) {
    C62 = 0.2296 * (C61 ** 0.3333);
  } else if (C61 <= 0.25) {
    C62 = 0.2296 * (C61 ** 0.3333);
  } else {
    C62 = 0.2296 * (C61 ** 0.3333);
  }
  let C63 = 0;
  let C58 = 0;
  if (C14 <= 0.4) {
    C63 = 2223105 * (C62 ** 3.7861) * ((C6 / C4) ** 1.0796) * (90 - C58) ** (- 1.3757);
  } else if (C14 >= 0.55) {
    C63 = 6919.3 * (C22 ** (- 1.3346)) * ((C7 / (C2 ** 3)) ** 2.0098) * ((C71 - 2) ** 1.4069);
  }
  let C64 = -0.9;
  let C65;
  if (C24 > 0.8) {
    C65 = 1.7301 - 0.7067 * C24;
  } else {
    C65 = 8.0798 * C24 - 13.8673 * (C24 ** 2) + 6.9844 * (C24 ** 3);
  }
  let C66 = C6 / C4;
  let C67 = 0;
  if (C14 <= 0.4) {
    C67 = 0.01404 * (C2 / C6) - 1.7525 * ((C7 ** (1 / 3)) / C2) - 4.7932 * (C4 / C2) - C65;
  } else if (C14 >= 0.55) {
    C67 = (-7.2035) * (C61 ** 0.3269) * (C66 ** 0.6054);
  }
  let C68 = (C2 ** 3) / C7;
  let C69;
  if (C68 <= 512) {
    C69 = -1.69385;
  } else if (C68 <= 1727) {
    C69 = 1.69385 + ((C68 ** (1 / 3)) - 8) / 2.36;
  } else {
    C69 = 0
  }
  let C70 = C69 * 0.4 * Math.exp(-0.034 * (C14 ** (-3.29)));
  let C72;
  if (C71 <= 12) {
    C72 = 1.446 * C24 - 0.03 * C71;
  } else {
    C72 = 1.446 * C24 - 0.36;
  }
  // let C73 = 0; // Can be a Input (Immersed area of the transom at zero speed)
  let C73 = $('#marine-calculator .modal input#immersed-area').val();
  if (C73 < 0) {
    $('#marine-calculator .modal input#immersed-area').val('0');
    setTimeout(function () {
      $('#marine-calculator .modal input#immersed-area').trigger('change');
    }, 100);
  }
  let C74 = 1 - 0.8 * C73 / (C4 * C6 * C22);
  // let C75 = C63*C57*C74*EXP(C67*(C14**C64))+C70*COS(C72*(C14**-2));
  let C57 = 0;
  let C75 = C63 * C57 * C74 * Math.exp(C67 * (C14 ** C64)) + C70 * Math.cos(C72 * (C14 ** (-2)));
  let C40 = 0;
  let C76 = C40 / C2;
  let C77;
  if (C76 >= 0.04) {
    C77 = 0.006 * ((C2 + 100) ** (- 0.16)) - 0.00205;
  } else {
    C77 = 0.006 * ((C2 + 100) ** (- 0.16)) - 0.00205 + 0.003 * ((C2 / 7.5) ** 2) * (C23 ** 4) * C57 * (0.04 - C76);
  }
  let C78 = C10 * 1000;
  let totalResistance = (0.001 * (0.5 * C8 * ((C12 * 0.5144) ** 2) * C32 * (C18 * C35 + C77) + C75 * C78)).toFixed(2);
  // Wave-making Resistance Calculations

  let theoreticalPowerValue = (totalResistance * C12 * 1852 / 3600);
  let actualPowerKWValue = (theoreticalPowerValue * (100 ** 4) / (propEfficiency * shaftLoss * electricalEfficiency * gearboxEfficiency));
  let actualPowerHPValue = (actualPowerKWValue * 1.341);
  let shaftSpeedValue = ((desiredSpeed * gearRatio * 1215.2) / (propPitch * (1 - propSlip / 100)));

  let theoreticalPower;
  let actualPower;
  let shaftSpeed;
  if (isNaN(theoreticalPowerValue)) {
    theoreticalPower = 'Cannot Calculate';
  } else if (!isFinite(theoreticalPowerValue)) {
    theoreticalPower = 'Infinity';
  } else {
    theoreticalPower = `${theoreticalPowerValue.toFixed(1)} kW`;
  }

  if (isNaN(actualPowerKWValue)) {
    actualPower = 'Cannot Calculate';
  } else if (!isFinite(actualPowerKWValue)) {
    actualPower = 'Infinity';
  } else {
    actualPower = `${actualPowerKWValue.toFixed(1)} kW or ${actualPowerHPValue.toFixed(1)} hp`;
  }

  if (isNaN(shaftSpeedValue)) {
    shaftSpeed = 'Cannot Calculate';
  } else if (!isFinite(shaftSpeedValue)) {
    shaftSpeed = 'Infinity';
  } else {
    shaftSpeed = `${shaftSpeedValue.toFixed(1)} RPM`;
  }

  if (C14 > 0.4 && C14 < 0.55) {
    $('#marine-calculator .results-wrp #theoretical-power').text('Outside range of tool');
    $('#marine-calculator .results-wrp #actual-power').text('Outside range of tool');
    $('#marine-calculator .results-wrp #shaft-speed').text('Outside range of tool');
  } else {
    $('#marine-calculator .results-wrp #theoretical-power').text(`${theoreticalPower}`);
    $('#marine-calculator .results-wrp #actual-power').text(`${actualPower}`);
    $('#marine-calculator .results-wrp #shaft-speed').text(`${shaftSpeed}`);
  }
}
// Marine Calculator

// Fan Power Calculator
function fanPowerCalculator() {
  if ($('#fan-power-calculator')) {
    //On Change
    $('#fan-power-calculator input').on('keyup change', function () {
      runFanPowerCalculation();
    });
    //On Change
  }
}

function calculatePumpAndFanJSON(fanPumpCalculatorJSON, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed) {
  fanPumpCalculatorJSON.forEach(motor => {
    motor.matchscoreA = Math.abs(motor.ccPerRev - flowrate1000rpm) + (motor.maxPressureBar >= pressure1000rpm ? 0 : 10000);
    motor.matchscoreB = Math.abs(motor.maxPressureBar - pressureMaxSpeed) + (motor.maxFlowRateLpm >= flowrateMaxSpeed ? 0 : 10000);
  });

  const sortedMatchscoreA = [...fanPumpCalculatorJSON].sort((a, b) => {
    if (a.matchscoreA === b.matchscoreA) {
      return a.frameSize - b.frameSize;
    }
    return a.matchscoreA - b.matchscoreA;
  });

  const sortedMatchscoreB = [...fanPumpCalculatorJSON].sort((a, b) => {
    if (a.matchscoreB === b.matchscoreB) {
      return a.frameSize - b.frameSize;
    }
    return a.matchscoreB - b.matchscoreB;
  });

  const noMatch = {
    frameSize: 'No Match',
    gearHousingWidth: 'No Match',
    ccPerRev: 'No Match',
    maxPressureBar: 'No Match',
    maxFlowRateLpm: 'No Match',
  };

  return {
    bestMatchA: sortedMatchscoreA[0].matchscoreA > 500 ? noMatch : sortedMatchscoreA[0],
    bestMatchB: sortedMatchscoreB[0].matchscoreB > 500 ? noMatch : sortedMatchscoreB[0],
    outputPower1000rpm: `${(Number(flowrate1000rpm) * Number(pressure1000rpm) / 600).toFixed(2)} kW`,
    outputPowerMaxSpeed: `${(Number(flowrateMaxSpeed) * Number(pressureMaxSpeed) / 600).toFixed(2)} kW`,
  };
}

function updateResults(newValues, newMotorData) {
  $('#fan-pump-calculator .results-frame-size-1000-rpm').text(newValues.bestMatchA.frameSize);
  $('#fan-pump-calculator .results-gear-housing-width-1000-rpm').text(newValues.bestMatchA.gearHousingWidth);
  $('#fan-pump-calculator .results-cc-rev-1000-rpm').text(newValues.bestMatchA.ccPerRev);
  $('#fan-pump-calculator .results-max-pressure-1000-rpm').text(newValues.bestMatchA.maxPressureBar);

  $('#fan-pump-calculator .results-frame-size-max-speed').text(newValues.bestMatchB.frameSize);
  $('#fan-pump-calculator .results-gear-housing-width-max-speed').text(newValues.bestMatchB.gearHousingWidth);
  $('#fan-pump-calculator .results-cc-rev-max-speed').text(newValues.bestMatchB.ccPerRev);
  $('#fan-pump-calculator .results-max-pressure-max-speed').text(newValues.bestMatchB.maxPressureBar);

  $('#fan-pump-calculator .results-motor-power-1000-rpm').text(newValues.outputPower1000rpm);
  $('#fan-pump-calculator .results-motor-power-max-speed').text(newValues.outputPowerMaxSpeed);

  // console.log('newMotorData', newMotorData);
  // console.log('newMotorData.bestMatchAt1000rpmPeak', newMotorData.bestMatchAt1000rpmPeak);

  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-1000-rpm').text(newMotorData.bestMatchAt1000rpmPeak ? `${newMotorData.bestMatchAt1000rpmPeak.motorFrame} ${newMotorData.bestMatchAt1000rpmPeak.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-1000-rpm-voltage').text(newMotorData.bestMatchAt1000rpmPeak ? `${newMotorData.bestMatchAt1000rpmPeak.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-1000-rpm-link').attr('href', newMotorData.bestMatchAt1000rpmPeak && newMotorData.bestMatchAt1000rpmPeak.pageLink ? newMotorData.bestMatchAt1000rpmPeak.pageLink.url : '#').attr('target', newMotorData.bestMatchAt1000rpmPeak && newMotorData.bestMatchAt1000rpmPeak.pageLink ? newMotorData.bestMatchAt1000rpmPeak.pageLink.target : '').text(newMotorData.bestMatchAt1000rpmPeak.pageLink.title);
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-1000-rpm-pdf').attr('href', newMotorData.bestMatchAt1000rpmPeak && newMotorData.bestMatchAt1000rpmPeak.pdfLink ? newMotorData.bestMatchAt1000rpmPeak.pdfLink : '#');

  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-max-speed').text(newMotorData.bestMatchAtMaxSpeedPeak ? `${newMotorData.bestMatchAtMaxSpeedPeak.motorFrame} ${newMotorData.bestMatchAtMaxSpeedPeak.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-max-speed-voltage').text(newMotorData.bestMatchAtMaxSpeedPeak ? `${newMotorData.bestMatchAtMaxSpeedPeak.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-max-speed-link').attr('href', newMotorData.bestMatchAtMaxSpeedPeak && newMotorData.bestMatchAtMaxSpeedPeak.pageLink ? newMotorData.bestMatchAtMaxSpeedPeak.pageLink.url : '#').attr('target', newMotorData.bestMatchAtMaxSpeedPeak && newMotorData.bestMatchAtMaxSpeedPeak.pageLink ? newMotorData.bestMatchAtMaxSpeedPeak.pageLink.target : '').text(newMotorData.bestMatchAtMaxSpeedPeak.pageLink.title);
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-max-speed-pdf').attr('href', newMotorData.bestMatchAtMaxSpeedPeak && newMotorData.bestMatchAtMaxSpeedPeak.pdfLink ? newMotorData.bestMatchAtMaxSpeedPeak.pdfLink : '#');

  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-both').text(newMotorData.bestMatchAtBothPeak ? `${newMotorData.bestMatchAtBothPeak.motorFrame} ${newMotorData.bestMatchAtBothPeak.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-both-voltage').text(newMotorData.bestMatchAtBothPeak ? `${newMotorData.bestMatchAtBothPeak.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-both-link').attr('href', newMotorData.bestMatchAtBothPeak && newMotorData.bestMatchAtBothPeak.pageLink ? newMotorData.bestMatchAtBothPeak.pageLink.url : '#').attr('target', newMotorData.bestMatchAtBothPeak && newMotorData.bestMatchAtBothPeak.pageLink ? newMotorData.bestMatchAtBothPeak.pageLink.target : '').text(newMotorData.bestMatchAtBothPeak && newMotorData.bestMatchAtBothPeak.pageLink ? newMotorData.bestMatchAtBothPeak.pageLink.title : '');
  $('#fan-pump-calculator .results-wrp .results-peak-motor-based-on-both-pdf').attr('href', newMotorData.bestMatchAtBothPeak && newMotorData.bestMatchAtBothPeak.pdfLink ? newMotorData.bestMatchAtBothPeak.pdfLink : '#');

  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-1000-rpm').text(newMotorData.bestMatchAt1000rpmContinuous ? `${newMotorData.bestMatchAt1000rpmContinuous.motorFrame} ${newMotorData.bestMatchAt1000rpmContinuous.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-1000-rpm-voltage').text(newMotorData.bestMatchAt1000rpmContinuous ? `${newMotorData.bestMatchAt1000rpmContinuous.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-1000-rpm-link').attr('href', newMotorData.bestMatchAt1000rpmContinuous && newMotorData.bestMatchAt1000rpmContinuous.pageLink ? newMotorData.bestMatchAt1000rpmContinuous.pageLink.url : '#').attr('target', newMotorData.bestMatchAt1000rpmContinuous && newMotorData.bestMatchAt1000rpmContinuous.pageLink ? newMotorData.bestMatchAt1000rpmContinuous.pageLink.target : '').text(newMotorData.bestMatchAt1000rpmContinuous.pageLink.title);
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-1000-rpm-pdf').attr('href', newMotorData.bestMatchAt1000rpmContinuous && newMotorData.bestMatchAt1000rpmContinuous.pdfLink ? newMotorData.bestMatchAt1000rpmContinuous.pdfLink : '#');

  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-max-speed').text(newMotorData.bestMatchAtMaxSpeedContinuous ? `${newMotorData.bestMatchAtMaxSpeedContinuous.motorFrame} ${newMotorData.bestMatchAtMaxSpeedContinuous.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-max-speed-voltage').text(newMotorData.bestMatchAtMaxSpeedContinuous ? `${newMotorData.bestMatchAtMaxSpeedContinuous.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-max-speed-link').attr('href', newMotorData.bestMatchAtMaxSpeedContinuous && newMotorData.bestMatchAtMaxSpeedContinuous.pageLink ? newMotorData.bestMatchAtMaxSpeedContinuous.pageLink.url : '#').attr('target', newMotorData.bestMatchAtMaxSpeedContinuous && newMotorData.bestMatchAtMaxSpeedContinuous.pageLink ? newMotorData.bestMatchAtMaxSpeedContinuous.pageLink.target : '').text(newMotorData.bestMatchAtMaxSpeedContinuous.pageLink.title);
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-max-speed-pdf').attr('href', newMotorData.bestMatchAtMaxSpeedContinuous && newMotorData.bestMatchAtMaxSpeedContinuous.pdfLink ? newMotorData.bestMatchAtMaxSpeedContinuous.pdfLink : '#');

  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-both').text(newMotorData.bestMatchAtBothContinuous ? `${newMotorData.bestMatchAtBothContinuous.motorFrame} ${newMotorData.bestMatchAtBothContinuous.motorLength}` : 'No Match');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-both-voltage').text(newMotorData.bestMatchAtBothContinuous ? `${newMotorData.bestMatchAtBothContinuous.voltage}` : '0');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-both-link').attr('href', newMotorData.bestMatchAtBothContinuous && newMotorData.bestMatchAtBothContinuous.pageLink ? newMotorData.bestMatchAtBothContinuous.pageLink.url : '#').attr('target', newMotorData.bestMatchAtBothContinuous && newMotorData.bestMatchAtBothContinuous.pageLink ? newMotorData.bestMatchAtBothContinuous.pageLink.target : '').text(newMotorData.bestMatchAtBothContinuous && newMotorData.bestMatchAtBothContinuous.pageLink ? newMotorData.bestMatchAtBothContinuous.pageLink.title : '');
  $('#fan-pump-calculator .results-wrp .results-continuous-motor-based-on-both-pdf').attr('href', newMotorData.bestMatchAtBothContinuous && newMotorData.bestMatchAtBothContinuous.pdfLink ? newMotorData.bestMatchAtBothContinuous.pdfLink : '#');
}

function calculateMotorData(fanPumpMotorDataJSON, motorVariationSelection, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed) {
  // Calculate required continuous power at 1000 rpm
  const requiredPowerAt1000Rpm = (flowrate1000rpm * pressure1000rpm) / 600;
  const requiredPowerAtMaxSpeed = (flowrateMaxSpeed * pressureMaxSpeed) / 600;
  let motorVariation;

  if (motorVariationSelection === 'dc-battery-selection') {
    motorVariation = 'DC Battery';
  } else if (motorVariationSelection === 'ac-mains-selection') {
    motorVariation = 'AC Mains';
  }

  // Filter by motor type (AC/DC) and sufficient power
  const matchingMotorsAt1000rpmPeak = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.peakPowerAt1000Rpm >= requiredPowerAt1000Rpm
  );

  const matchingMotorsAt1000rpmContinuous = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.contPowerAt1000Rpm >= requiredPowerAt1000Rpm
  );

  const matchingMotorsAtMaxSpeedPeak = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.peakPowerAtMaxSpeed >= requiredPowerAtMaxSpeed
  );

  const matchingMotorsAtMaxSpeedContinuous = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.contPowerAtMaxSpeed >= requiredPowerAtMaxSpeed
  );

  const matchingMotorsAtBothPeak = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.peakPowerAtMaxSpeed >= requiredPowerAtMaxSpeed && motor.peakPowerAt1000Rpm >= requiredPowerAt1000Rpm
  );

  const matchingMotorsAtBothContinuous = fanPumpMotorDataJSON.filter(
    (motor) =>
      motor.acDc === motorVariation &&
      motor.contPowerAtMaxSpeed >= requiredPowerAtMaxSpeed && motor.contPowerAt1000Rpm >= requiredPowerAt1000Rpm
  );

  let bestMatchAt1000rpmPeak;
  let bestMatchAt1000rpmContinuous;
  let bestMatchAtMaxSpeedPeak;
  let bestMatchAtMaxSpeedContinuous;
  let bestMatchAtBothPeak;
  let bestMatchAtBothContinuous;

  if (matchingMotorsAt1000rpmPeak.length > 0) {
    bestMatchAt1000rpmPeak = matchingMotorsAt1000rpmPeak.reduce((prev, curr) =>
      curr.peakPowerAt1000Rpm < prev.peakPowerAt1000Rpm ? curr : prev
    );
  } else {
    bestMatchAt1000rpmPeak = null;
  }

  if (matchingMotorsAt1000rpmContinuous.length > 0) {
    bestMatchAt1000rpmContinuous = matchingMotorsAt1000rpmContinuous.reduce((prev, curr) =>
      curr.contPowerAt1000Rpm < prev.contPowerAt1000Rpm ? curr : prev
    );
  } else {
    bestMatchAt1000rpmContinuous = null;
  }

  if (matchingMotorsAtMaxSpeedPeak.length > 0) {
    bestMatchAtMaxSpeedPeak = matchingMotorsAtMaxSpeedPeak.reduce((prev, curr) =>
      curr.peakPowerAtMaxSpeed < prev.peakPowerAtMaxSpeed ? curr : prev
    );
  } else {
    bestMatchAtMaxSpeedPeak = null;
  }

  if (matchingMotorsAtMaxSpeedContinuous.length > 0) {
    bestMatchAtMaxSpeedContinuous = matchingMotorsAtMaxSpeedContinuous.reduce((prev, curr) =>
      curr.contPowerAtMaxSpeed < prev.contPowerAtMaxSpeed ? curr : prev
    );
  } else {
    bestMatchAtMaxSpeedContinuous = null;
  }

  if (matchingMotorsAtBothPeak.length > 0) {
    bestMatchAtBothPeak = matchingMotorsAtBothPeak.reduce((prev, curr) =>
      curr.peakPowerAtMaxSpeed < prev.peakPowerAtMaxSpeed ? curr : prev
    );
  } else {
    bestMatchAtBothPeak = null;
  }

  if (matchingMotorsAtBothContinuous.length > 0) {
    bestMatchAtBothContinuous = matchingMotorsAtBothContinuous.reduce((prev, curr) =>
      curr.contPowerAtMaxSpeed < prev.contPowerAtMaxSpeed ? curr : prev
    );
  } else {
    bestMatchAtBothContinuous = null;
  }

  return {
    requiredPowerAt1000Rpm,
    requiredPowerAtMaxSpeed,
    bestMatchAt1000rpmPeak: bestMatchAt1000rpmPeak,
    bestMatchAtMaxSpeedPeak: bestMatchAtMaxSpeedPeak,
    bestMatchAtBothPeak: bestMatchAtBothPeak,
    bestMatchAt1000rpmContinuous: bestMatchAt1000rpmContinuous,
    bestMatchAtMaxSpeedContinuous: bestMatchAtMaxSpeedContinuous,
    bestMatchAtBothContinuous: bestMatchAtBothContinuous,
  };
}

function validatePumpAndFanInputs(flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed) {
  const errors = [];

  // Convert to numbers for validation
  const f1000 = parseFloat(flowrate1000rpm);
  const p1000 = parseFloat(pressure1000rpm);
  const fMax = parseFloat(flowrateMaxSpeed);
  const pMax = parseFloat(pressureMaxSpeed);

  // Check for empty or invalid inputs
  if (isNaN(f1000) || f1000 <= 0) {
    errors.push('Flowrate at 1000 RPM must be a positive number.');
  }

  if (isNaN(p1000) || p1000 <= 0) {
    errors.push('Pressure at 1000 RPM must be a positive number.');
  }

  if (isNaN(fMax) || fMax <= 0) {
    errors.push('Flowrate at Max Speed must be a positive number.');
  }

  if (isNaN(pMax) || pMax <= 0) {
    errors.push('Pressure at Max Speed must be a positive number.');
  }

  return errors;
}

function pumpAndFanPowerCalculator(fanPumpCalculatorJSON, fanPumpMotorDataJSON) {
  // Guard clause to check for fan-pump-calculator id
  if (!$('#fan-pump-calculator').length) return;

  // Initial Load
  const flowrate1000rpm = $('#required-flowrate-1000rpm').val();
  const pressure1000rpm = $('#required-max-pressure-1000rpm').val();
  const flowrateMaxSpeed = $('#required-flowrate-max-speed').val();
  const pressureMaxSpeed = $('#required-max-pressure-max-speed').val();
  // const motorVariationSelection = $('#fan-pump-calculator .select-calculation-motor-source').val();
  const motorVariationSelection = $('#fan-pump-calculator input[name="select-calculation-motor-source"]:checked').val();

  const usePoint = $('#fan-pump-calculator .select-use-point').val();
  const dutyType = $('#fan-pump-calculator .select-duty-type').val();
  usePointChanges(usePoint, dutyType);
  dutyTypeChanges(dutyType, usePoint);

  const newValues = calculatePumpAndFanJSON(fanPumpCalculatorJSON, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed);
  const newMotorData = calculateMotorData(fanPumpMotorDataJSON, motorVariationSelection, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed);

  // console.log('newMotorData', newMotorData);
  updateResults(newValues, newMotorData);

  // Initial Load

  $('#fan-pump-calculator input, #fan-pump-calculator input[name="select-calculation-motor-source"]').on('keyup change', function () {
    const flowrate1000rpm = $('#required-flowrate-1000rpm').val();
    const pressure1000rpm = $('#required-max-pressure-1000rpm').val();
    const flowrateMaxSpeed = $('#required-flowrate-max-speed').val();
    const pressureMaxSpeed = $('#required-max-pressure-max-speed').val();
    const errorContainer = $('#fan-pump-calculator .error-container');
    const validationErrors = validatePumpAndFanInputs(flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed);

    if (validationErrors.length > 0) {
      errorContainer.html(validationErrors.map(err => `<div>• ${err}</div>`).join(''));
      return;
    } else {
      errorContainer.empty();
      const motorVariationSelection = $('#fan-pump-calculator input[name="select-calculation-motor-source"]:checked').val();

      const newValues = calculatePumpAndFanJSON(fanPumpCalculatorJSON, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed);
      const newMotorData = calculateMotorData(fanPumpMotorDataJSON, motorVariationSelection, flowrate1000rpm, pressure1000rpm, flowrateMaxSpeed, pressureMaxSpeed);

      // console.log('newMotorData', newMotorData);
      updateResults(newValues, newMotorData);
    }
  });

  $('#fan-pump-calculator .select-duty-type').on('keyup change', function () {
    const dutyType = $('#fan-pump-calculator .select-duty-type').val();
    const usePoint = $('#fan-pump-calculator .select-use-point').val();

    dutyTypeChanges(dutyType, usePoint);
  });

  $('#fan-pump-calculator .select-use-point').on('keyup change', function () {
    const usePoint = $('#fan-pump-calculator .select-use-point').val();
    const dutyType = $('#fan-pump-calculator .select-duty-type').val();

    usePointChanges(usePoint, dutyType);

  });
}

function usePointChanges(usePoint, dutyType) {
  dutyTypeChanges(dutyType, usePoint);

  if (usePoint === 'at-1000rpm') {
    $('#fan-pump-calculator .1000rpm-result-wrp').css('display', 'flex');
    $('#fan-pump-calculator .max-speed-result-wrp').css('display', 'none');
    $('#fan-pump-calculator .1000rpm-selection').css('display', 'grid');
    $('#fan-pump-calculator .at-top-speed-selection').css('display', 'none');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-top-speed');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-both');
    $('#fan-pump-calculator .results-wrp-outer').addClass('at-1000rpm');

    $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'flex');

    $('#fan-pump-calculator .mobile-result-wrp .left-side-1000-rpm-outer-wrp').css('display', 'block');
    $('#fan-pump-calculator .mobile-result-wrp .left-side-max-speed-outer-wrp').css('display', 'none');
  } else if (usePoint === 'at-top-speed') {
    $('#fan-pump-calculator .1000rpm-result-wrp').css('display', 'none');
    $('#fan-pump-calculator .max-speed-result-wrp').css('display', 'flex');
    $('#fan-pump-calculator .1000rpm-selection').css('display', 'none');
    $('#fan-pump-calculator .at-top-speed-selection').css('display', 'grid');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-1000rpm');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-both');
    $('#fan-pump-calculator .results-wrp-outer').addClass('at-top-speed');

    $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'flex');

    $('#fan-pump-calculator .mobile-result-wrp .left-side-1000-rpm-outer-wrp').css('display', 'none');
    $('#fan-pump-calculator .mobile-result-wrp .left-side-max-speed-outer-wrp').css('display', 'block');
  } else if (usePoint === 'both') {
    $('#fan-pump-calculator .1000rpm-result-wrp').css('display', 'flex');
    $('#fan-pump-calculator .max-speed-result-wrp').css('display', 'flex');
    $('#fan-pump-calculator #additional-info-container-max-speed .both-wrp').hide();
    $('#fan-pump-calculator .1000rpm-selection').css('display', 'grid');
    $('#fan-pump-calculator .at-top-speed-selection').css('display', 'grid');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-1000rpm');
    $('#fan-pump-calculator .results-wrp-outer').removeClass('at-top-speed');
    $('#fan-pump-calculator .results-wrp-outer').addClass('at-both');

    $('#fan-pump-calculator .mobile-result-wrp .left-side-1000-rpm-outer-wrp').css('display', 'block');
    $('#fan-pump-calculator .mobile-result-wrp .left-side-max-speed-outer-wrp').css('display', 'block');

    if (dutyType == 'both') {
      console.log('at both both');
      $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'none');
      $('#fan-pump-calculator .results-wrp-outer').addClass('duty-both');
    } else {
      $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'flex');
    }
  }
}

function dutyTypeChanges(dutyType, usePoint) {
  $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'flex');

  if (dutyType === 'peak') {
    $('#fan-pump-calculator .results-wrp-outer').removeClass('duty-both duty-continuous');
    $('#fan-pump-calculator .results-wrp-outer').addClass('duty-peak');
    $('#fan-pump-calculator .peak-wrp').show();
    $('#fan-pump-calculator .continuous-wrp').hide();
    $('#fan-pump-calculator .both-wrp').hide();
  } else if (dutyType === 'continuous') {
    $('#fan-pump-calculator .results-wrp-outer').removeClass('duty-both duty-peak');
    $('#fan-pump-calculator .results-wrp-outer').addClass('duty-continuous');
    $('#fan-pump-calculator .peak-wrp').hide();
    $('#fan-pump-calculator .continuous-wrp').show();
    $('#fan-pump-calculator .both-wrp').hide();
  } else if (dutyType === 'both') {
    $('#fan-pump-calculator .results-wrp-outer').removeClass('duty-peak duty-continuous');
    $('#fan-pump-calculator .results-wrp-outer').addClass('duty-both')
    $('#fan-pump-calculator .peak-wrp').show();
    $('#fan-pump-calculator .continuous-wrp').show();
    $('#fan-pump-calculator .both-wrp').hide();

    if (usePoint == 'both') {
      $('#fan-pump-calculator .max-speed-result-wrp .right-side').css('display', 'none');
      $('#fan-pump-calculator .results-wrp-outer').addClass('at-both')
      $('#fan-pump-calculator .peak-wrp').hide();
      $('#fan-pump-calculator .continuous-wrp').hide();
      $('#fan-pump-calculator .both-wrp').show();
    }
  }
}

function runFanPowerCalculation() {
  let pressureIncrease = $('#fan-power-calculator input#pressure-increase').val();
  if (pressureIncrease < 0) {
    $('#fan-power-calculator input#pressure-increase').val('120');
    setTimeout(function () {
      $('#fan-power-calculator input#pressure-increase').trigger('change');
    }, 100);
  }
  let airFlow = $('#fan-power-calculator input#air-flow').val();
  if (airFlow < 0) {
    $('#fan-power-calculator input#air-flow').val('1.5');
    setTimeout(function () {
      $('#fan-power-calculator input#air-flow').trigger('change');
    }, 100);
  }
  let fanEfficiency = $('#fan-power-calculator input#fan-efficiency').val();
  if (fanEfficiency < 0 || fanEfficiency > 100) {
    $('#fan-power-calculator input#fan-efficiency').val('80');
    setTimeout(function () {
      $('#fan-power-calculator input#fan-efficiency').trigger('change');
    }, 100);
  }
  let beltEfficiency = $('#fan-power-calculator input#belt-efficiency').val();
  if (beltEfficiency < 0 || beltEfficiency > 100) {
    $('#fan-power-calculator input#belt-efficiency').val('50');
    setTimeout(function () {
      $('#fan-power-calculator input#belt-efficiency').trigger('change');
    }, 100);
  }
  let motorEfficiency = $('#fan-power-calculator input#motor-efficiency').val();
  if (motorEfficiency < 0 || motorEfficiency > 100) {
    $('#fan-power-calculator input#motor-efficiency').val('75');
    setTimeout(function () {
      $('#fan-power-calculator input#motor-efficiency').trigger('change');
    }, 100);
  }

  let fanPower = pressureIncrease * airFlow * (100 ** 3) / (fanEfficiency * beltEfficiency * motorEfficiency);
  let fanPowerValue;
  if (isNaN(fanPower)) {
    fanPowerValue = 'Cannot Calculate';
  } else if (!isFinite(fanPower)) {
    fanPowerValue = 'Infinity';
  } else if (fanPower < 0) {
    fanPowerValue = '';
  } else {
    fanPowerValue = `${fanPower.toFixed(1)} W`;
  }

  $('#fan-power-calculator .results-wrp #fan-power').text(`${fanPowerValue}`);

}
// Fan Power Calculator

function editorContentAdditions() {
  //wrap all buttons with a wrapper to handle responsive - This works with "Add Buttons" feature in the wp editor
  var target = '.btn',
    invert = ':not(' + target + ')',
    wrap = '<div class="button-wrapper">',
    breakpoints = $('.editor-content-wrp > *' + invert);

  $('.editor-content-wrp').each(function () {
    $(this).find('.btn').unwrap();
  });

  breakpoints.each(function () {
    $(this).nextUntil(invert).wrapAll(wrap);
  });

  breakpoints.first().prevUntil(invert).wrapAll(wrap);
  //wrap all buttons with a wrapper to handle responsive - This works with "Add Buttons" feature in the wp editor
}

function pumpAndFanLinkCollect() {
  $('.results-grid-wrps').on('click', 'a.btn.learn-more-btn', function (e) {
    $('.datasheet-msg').remove();
    e.preventDefault();

    let itemLink = ($(this).attr('href') || '').trim();

    if (itemLink && itemLink !== '#') {
      downloadUrl = itemLink;
    } else {
      const container = $('#product-data-popup-form-wrp .content-wrp');

      // Only prepend if not already added
      if (container.find('.datasheet-msg').length === 0) {
        container.prepend(
          '<h4 class="datasheet-msg">Please fill out below details, we will email you the datasheet.</h4>'
        );
      }
    }

    $('#product-data-popup-form-wrp').slideDown('slow');
  });


  $('.results-grid-wrps').on('click', '.pump-info', function (e) {
    $('.datasheet-msg').remove();
    e.preventDefault();

    let pumpLink = ($(this).attr('href') || '').trim();

    if (pumpLink && pumpLink !== '#') {
      downloadUrl = pumpLink;
    } else {
      const container = $('#product-data-popup-form-wrp .content-wrp');

      // Only prepend if not already added
      if (container.find('.datasheet-msg').length === 0) {
        container.prepend(
          '<h4 class="datasheet-msg">Please fill out below details, we will email you the datasheet.</h4>'
        );
      }
    }

    $('#product-data-popup-form-wrp').slideDown('slow');
  });
}
